import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import Header from "./Header";
import aboutImg from "./assets/img/aboutImg.png";
import opticalCharRecImg1 from "./assets/img/opticalCharRecImg-1.png";
import opticalCharRecImg2 from "./assets/img/opticalCharRecImg-2.png";
import opticalCharRecImg3 from "./assets/img/opticalCharRecImg-3.png";

import caseStudyIco1 from "./assets/img/caseStudyIco-1.png";
import productsliderImg1 from "./assets/img/productsliderImg-1.png";
import productsliderImg2 from "./assets/img/productsliderImg-2.png";

import AIPoweredIco1 from "./assets/img/AIPoweredIco-1.png";
import AIPoweredIco2 from "./assets/img/AIPoweredIco-2.png";
import AIPoweredIco3 from "./assets/img/AIPoweredIco-3.png";
import AIPoweredIco4 from "./assets/img/AIPoweredIco-4.png";
import GenerativeAIIco1 from "./assets/img/GenerativeAIIco-1.png";
import GenerativeAIIco2 from "./assets/img/GenerativeAIIco-2.png";
import GenerativeAIIco3 from "./assets/img/GenerativeAIIco-3.png";
import GenerativeAIIco4 from "./assets/img/GenerativeAIIco-4.png";
import DigitalHealthIco1 from "./assets/img/DigitalHealthIco-1.png";
import DigitalHealthIco2 from "./assets/img/DigitalHealthIco-2.png";
import DigitalHealthIco3 from "./assets/img/DigitalHealthIco-3.png";
import DigitalHealthIco4 from "./assets/img/DigitalHealthIco-4.png";
import DigitalHealthIco5 from "./assets/img/DigitalHealthIco-5.png";
import DigitalHealthIco6 from "./assets/img/DigitalHealthIco-6.png";

const AIMLDetails = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const initialSection = splitLocation[1] || "aiPowered";
  let pageTitle, pageDescription, pageKeyWords, canonicalLink;

  switch (initialSection) {
    case "opticalCharRec":
      pageTitle =
        "Optimize Your Operations with OCR & Image Processing Services | Hummingtec";
      pageDescription =
        "Transform your digital assets with Hummingtec's OCR and Image Processing services. Experience efficiency, accuracy, and enhanced image quality to streamline operations and unlock insights.";
      pageKeyWords =
        "OCR services, image processing, digital transformation, text recognition, document accessibility, Tesseract OCR, OpenCV, Adobe Sensei, ABBYY FineReader, Hummingtec solutions";
      canonicalLink = "https://www.hummingtec.com/opticalCharRec";
      break;
    case "aiDrivenIn":
      pageTitle =
        "AI-Driven Insights & Forecasting Services | Gain a Competitive Edge | Hummingtec";
      pageDescription =
        "Utilize Hummingtec's AI-driven insights for prediction and load forecasting to reduce costs, improve resource planning, enhance customer satisfaction, and drive strategic decisions. Transform data into a competitive advantage.";
      pageKeyWords =
        "AI-driven insights, prediction services, load forecasting, artificial intelligence, data analysis, cost reduction, resource planning, customer satisfaction, strategic decisions, competitive edge, Hummingtec";
      canonicalLink = "https://www.hummingtec.com/aiDrivenIn";
      break;
    case "generativeAi":
      pageTitle =
        "Generative AI in Fashion Design | Innovative Garment Creation | Hummingtec";
      pageDescription =
        "Discover the future of fashion with Hummingtec's Generative AI technology. Revolutionize garment design with AI-driven creativity, efficiency, and sustainability. Explore personalized, trend-setting designs today.";
      pageKeyWords =
        "Generative AI, fashion design, garment creation, AI in fashion, sustainable fashion, personalized design, trend analysis, Hummingtec, artificial intelligence, fashion innovation";
      canonicalLink = "https://www.hummingtec.com/generativeAi";
      break;
    case "digitalHealth":
      pageTitle =
        "Hummingtec Digital Health Assistant | Your 24/7 Personal Health Companion";
      pageDescription =
        "Experience personalized healthcare with Hummingtec's Digital Health Assistant. From AI-powered health insights to seamless wearable integration, manage your wellness journey effortlessly and securely.";
      pageKeyWords =
        "Digital Health Assistant, personalized healthcare, AI health insights, health tracking, medication reminders, health education, secure health data, Hummingtec health platform";
      canonicalLink = "https://www.hummingtec.com/digitalHealth";
      break;
    case "vehicleRouteOpt":
      pageTitle =
        "AI-Powered Vehicle Route Optimization | Maximize Fleet Efficiency | Hummingtec";
      pageDescription =
        "Transform your fleet operations with Hummingtec's AI-powered Vehicle Route Optimization. Achieve optimal planning, reduce costs, and enhance customer satisfaction with our advanced AI solutions.";
      pageKeyWords =
        "vehicle route optimization, AI-powered logistics, fleet management efficiency, artificial intelligence, operational cost reduction, customer satisfaction, Hummingtec fleet solutions";
      canonicalLink = "https://www.hummingtec.com/vehicleRouteOpt";
      break;
    case "GPTModelTraining":
      pageTitle =
        "Custom GPT Model Creation & Training | Advanced AI & NLP Services | Hummingtec";
      pageDescription =
        "Unlock the potential of AI with Hummingtec's GPT Model Creation and Training services. Experience advanced NLP technology for automating tasks, generating insights, and creating interactive AI experiences.";
      pageKeyWords =
        "GPT model creation, NLP services, AI chatbots, content automation, data analysis, OpenAI GPT-3, TensorFlow, PyTorch, Hugging Face Transformers, cloud AI, Hummingtec AI solutions";
      canonicalLink = "https://www.hummingtec.com/GPTModelTraining";
      break;
    case "AIChatbots":
      pageTitle =
        "AI Chatbot Solutions by Hummingtec: Enhance Your Customer Experience 24/7";
      pageDescription =
        "Elevate your customer engagement with Hummingtec's AI chatbots. Leveraging NLP and ML, our chatbots offer personalized, instant communication to automate customer service, sales, and marketing efficiently.";
      pageKeyWords =
        "AI chatbots, digital communication, customer service automation, natural language processing, machine learning, Dialogflow, Microsoft Bot Framework, IBM Watson, Rasa, chatbot technology";
      canonicalLink = "https://www.hummingtec.com/AIChatbots";
      break;
    case "forecastingAndPrediction":
      pageTitle =
        "Data Analytics Services: Drive Growth with Predictive Insights | Hummingtec";
      pageDescription =
        "Harness the power of data with Hummingtec's Prediction, Forecasting, and Analytics services. Transform data into actionable insights for informed decision-making, trend prediction, and operational optimization.";
      pageKeyWords =
        "data analytics, predictive forecasting, business insights, data-driven decisions, machine learning, Python, R, TensorFlow, PyTorch, Tableau, Power BI, SQL, NoSQL, Hummingtec analytics solutions";
      canonicalLink = "https://www.hummingtec.com/forecastingAndPrediction";
      break;
    case "leadGeneration":
      pageTitle =
        "AI-Powered Lead Generation Services | Transform Your Sales Strategy | Hummingtec";
      pageDescription =
        "Elevate your sales with Hummingtec's AI-driven Lead Generation services. Harness predictive analytics, NLP, and data mining to identify and engage high-quality leads efficiently. Experience targeted, efficient lead conversion today.";
      pageKeyWords =
        "AI lead generation, sales automation, predictive analytics, NLP, data mining, CRM integration, marketing strategies, artificial intelligence, Hummingtec services";
      canonicalLink = "https://www.hummingtec.com/leadGeneration";
      break;
    default:
      pageTitle = "Revolutionary AI Medical Transport Solution | Hummingtec";
      pageDescription =
        "Discover Hummingtec's AI-driven solution for Medical Transport, optimizing NEMT with smart scheduling, seamless communication, and adaptability for healthcare providers.";
      pageKeyWords =
        "AI Medical Transport, healthcare transportation, NEMT optimization, machine learning healthcare, real-time traffic adjustments, healthcare compliance, Hummingtec innovation";
      canonicalLink = "https://www.hummingtec.com/aiPowered";
      break;
  }

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeyWords} />
        <link rel="canonical" href={canonicalLink} />
      </Helmet>
      <Header></Header>
      <div className="mainContent">
        {(initialSection === "aiPowered" || pathname === "/AIMLDetails") && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>AI-Powered Transport Solution</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>AI-Powered Transport Solution</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        At Hummingtec, we're proud to unveil our latest
                        innovation: a state-of-the-art AI solution specifically
                        engineered for Medical Transport (MT). Designed with
                        precision and user-friendliness in mind, our system is
                        set to revolutionize healthcare transportation services.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={AIPoweredIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Optimized Scheduling and Routing for NEMT</h2>
                              <p>
                                Leveraging cutting-edge machine learning
                                algorithms, the system dynamically optimizes
                                routes for maximum efficiency. It's not just
                                about getting there; it's about getting there
                                smartly.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={AIPoweredIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Adaptable and Responsive</h2>
                              <p>
                                In the world of healthcare transportation,
                                adaptability is key. Our system is designed to
                                adjust in real-time to traffic conditions and
                                schedule changes, maintaining operational
                                reliability and punctuality even amidst
                                unpredictability.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={AIPoweredIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Seamless Communication</h2>
                              <p>
                                The user-friendly interface of our system offers
                                real-time updates, bridging the communication
                                gap between drivers and healthcare providers
                                seamlessly. This ensures that everyone involved
                                is on the same page, enhancing the overall
                                coordination and efficacy of the service.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={AIPoweredIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Tailored for Healthcare Transportation</h2>
                              <p>
                                Understanding the unique challenges, we've
                                tailored our solution to cater specifically to
                                the needs. From ensuring compliance with
                                healthcare standards to addressing the specific
                                requirements of each patient, our system is a
                                comprehensive answer to the complexities of
                                healthcare transportation.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Benefits at a Glance</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="m17.849 386.24 38.004 12.992 12.993-38.003"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M55.977 399.232C27.039 358.888 10 309.437 10 256 10 120.138 120.138 10 256 10c53.437 0 102.888 17.039 143.232 45.977M494.151 125.76l-38.004-12.992-12.993 38.003"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M456.023 112.768C484.961 153.112 502 202.563 502 256c0 135.862-110.138 246-246 246-53.437 0-102.888-17.039-143.232-45.977"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M426.694 291.316v-70.632h-46.078a128.704 128.704 0 0 0-11.54-27.816l32.595-32.595-49.944-49.944-32.595 32.595a128.696 128.696 0 0 0-27.815-11.54V85.306h-70.632v46.078a128.675 128.675 0 0 0-27.815 11.54l-32.595-32.595-49.944 49.944 32.595 32.595a128.683 128.683 0 0 0-11.54 27.816h-46.08v70.632h46.078a128.675 128.675 0 0 0 11.54 27.815l-32.595 32.595 49.944 49.944 32.595-32.595a128.683 128.683 0 0 0 27.816 11.54v46.078h70.632v-46.078a128.675 128.675 0 0 0 27.815-11.54l32.595 32.595 49.944-49.944-32.595-32.595a128.696 128.696 0 0 0 11.54-27.815h46.079z"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                  opacity="0.45"
                                ></path>
                                <circle
                                  cx="256"
                                  cy="256"
                                  r="86.351"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                ></circle>
                                <path
                                  d="M256 210.816V256h35.143"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#9ceebd"
                                  opacity="0.45"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Enhanced Efficiency</h2>
                            <p>
                              Optimal routes and schedules mean more timely
                              service.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M20 51a12 12 0 0 0 20.944 8l-1.49-1.333A10 10 0 1 1 42 51c0 .31-.03.616-.058.923L40.8 50.4l-1.6 1.2 3 4a1 1 0 0 0 1.6 0l3-4-1.6-1.2-1.268 1.691c.032-.362.068-.725.068-1.091a12 12 0 0 0-24 0z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m31 51.382-3.447 1.723.894 1.79 4-2A1 1 0 0 0 33 52v-8h-2zM49 50h14v2H49zM1 50h17v2H1zM13 48V26a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v22h2V27h6v21zM28 15h-8a1 1 0 0 0-1 1v26h2V17h6v20h2V16a1 1 0 0 0-1-1zM45 42V26a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v11h2V27h6v15zM61 48V16a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v32h2V17h6v31z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M56 9a4 4 0 1 0-4-4 3.952 3.952 0 0 0 .2 1.2l-9.456 5.9a3.978 3.978 0 0 0-5.575.073L26.83 6.09A3.935 3.935 0 0 0 27 5a4 4 0 1 0-7.7 1.522l-9.818 7.366A3.96 3.96 0 0 0 7 13a4.009 4.009 0 1 0 3.7 2.478l9.822-7.366a3.956 3.956 0 0 0 5.313-.289L36.17 13.91A3.935 3.935 0 0 0 36 15a4 4 0 0 0 8 0 3.952 3.952 0 0 0-.2-1.2l9.456-5.9A3.978 3.978 0 0 0 56 9zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM7 19a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM23 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm17 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Real-Time Adaptability</h2>
                            <p>
                              Stay ahead of changes and traffic with AI-driven
                              adjustments.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512.001"
                            >
                              <g>
                                <path
                                  d="M94.695 272.055h155.317a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5H94.695a7.5 7.5 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5zM94.695 306.383h155.317c4.144 0 7.5-3.356 7.5-7.5a7.496 7.496 0 0 0-7.5-7.496H94.695a7.496 7.496 0 0 0-7.5 7.496c0 4.144 3.356 7.5 7.5 7.5zM94.695 340.715h155.317a7.5 7.5 0 1 0 0-15H94.695a7.5 7.5 0 1 0 0 15zM94.695 374.695h155.317c4.144 0 7.5-3.355 7.5-7.5a7.496 7.496 0 0 0-7.5-7.496H94.695a7.496 7.496 0 0 0-7.5 7.496c0 4.145 3.356 7.5 7.5 7.5zM94.695 409.027h155.317c4.144 0 7.5-3.359 7.5-7.5s-3.356-7.5-7.5-7.5H94.695a7.5 7.5 0 1 0 0 15zM392.277 103.027h-155.32c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5h155.32c4.141 0 7.5-3.359 7.5-7.5s-3.359-7.5-7.5-7.5zM392.277 137.36h-155.32a7.499 7.499 0 1 0 0 14.995h155.32a7.499 7.499 0 1 0 0-14.996zm0 0"
                                  fill="#cf8fff"
                                  opacity="0.45"
                                  data-original="#cf8fff"
                                ></path>
                                <path
                                  d="M478.734 189.098c-4.09-.618-7.918 2.199-8.535 6.293-4.969 32.894-19.797 62.777-42.883 86.418-13.93 14.261-16.078 36.789-5.109 53.57l3.676 5.621-58.098-14.867c-10.86-2.781-18.484-.594-23.05.293.015-24.598-5.231-49.067-15.29-71.426h62.832c4.141 0 7.5-3.36 7.5-7.5s-3.359-7.5-7.5-7.5H321.79a170.049 170.049 0 0 0-12.934-19.332h83.422a7.499 7.499 0 1 0 0-14.996h-96.48a173.165 173.165 0 0 0-21.996-18.984h118.472a7.5 7.5 0 1 0 0-15H249.06c-28.02-13.895-59.23-19.727-90.836-16.965C168.09 64.359 252.809-.512 345.703 18.262c73.406 14.84 121.719 75.816 125.965 143.722a7.498 7.498 0 0 0 7.953 7.016 7.502 7.502 0 0 0 7.016-7.953C482.012 87.113 429.453 19.89 348.676 3.563 245.262-17.344 152 56.39 142.969 156.715 49.703 173.035-8.02 256.925.906 343.555c3.98 38.636 21.035 75.133 48.02 102.761 9.054 9.27 10.433 23.942 3.285 34.883l-8.203 12.551c-5.867 8.984 2.39 20.527 12.789 17.86l66.105-16.919c4.22-1.082 8.594-1.183 12.657-.296a172.109 172.109 0 0 0 24.011 3.476 7.49 7.49 0 0 0 8.028-6.93 7.498 7.498 0 0 0-6.93-8.027 156.892 156.892 0 0 1-21.91-3.172c-6.332-1.383-13.102-1.238-19.574.418L61.09 495.031l3.676-5.625c10.964-16.781 8.816-39.308-5.114-53.566-85.011-87.055-42.922-238.375 81.614-263.547 137.363-27.777 238.543 123.863 162.8 239.773-24.855 38.036-64.945 63.461-109.988 69.754a7.498 7.498 0 0 0-6.39 8.465 7.503 7.503 0 0 0 8.464 6.39c79.621-11.128 140.7-75.8 147.887-154.878 7.977-1.371 12.18-3.14 20.027-1.133l66.106 16.918c10.402 2.664 18.66-8.875 12.785-17.86l-8.2-12.55c-7.148-10.942-5.769-25.61 3.286-34.883 25.3-25.902 41.547-58.637 46.984-94.656a7.495 7.495 0 0 0-6.293-8.535zm0 0"
                                  fill="#cf8fff"
                                  opacity="1"
                                  data-original="#cf8fff"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Improved Communication</h2>
                            <p>
                              A user-friendly platform keeps drivers and
                              healthcare providers connected.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 32 32"
                            >
                              <g>
                                <path
                                  d="M16.5 4h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zM20.5 31h-11A2.503 2.503 0 0 1 7 28.5v-7a.5.5 0 0 1 1 0v7c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-17a.5.5 0 0 1 1 0v17c0 1.378-1.121 2.5-2.5 2.5z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M22.5 5a.5.5 0 0 1-.5-.5v-1c0-.827-.673-1.5-1.5-1.5h-11C8.673 2 8 2.673 8 3.5v1a.5.5 0 0 1-1 0v-1C7 2.122 8.121 1 9.5 1h11C21.879 1 23 2.122 23 3.5v1a.5.5 0 0 1-.5.5zM14.5 25h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1zM17.5 27h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM19.5 23h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1zM9 14c-1.379 0-2.5-1.122-2.5-2.5S7.621 9 9 9s2.5 1.122 2.5 2.5S10.379 14 9 14zm0-4c-.827 0-1.5.673-1.5 1.5S8.173 13 9 13s1.5-.673 1.5-1.5S9.827 10 9 10zM9 20a6.98 6.98 0 0 1-4.739-1.862.5.5 0 0 1-.146-.487A3.477 3.477 0 0 1 7.5 15h3a3.48 3.48 0 0 1 3.386 2.65.5.5 0 0 1-.146.487A6.98 6.98 0 0 1 9 20zm-3.827-2.393c2.162 1.801 5.492 1.801 7.654 0A2.48 2.48 0 0 0 10.5 16h-3a2.48 2.48 0 0 0-2.327 1.607z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M9 20c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zM9 7c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM4.5 22.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM4.5 24.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM4.5 26.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM24.34 27h-.84a.5.5 0 0 1 0-1h.437l.245-1.135a.498.498 0 0 1 .371-.38 4.791 4.791 0 0 0 1.367-.571.5.5 0 0 1 .529.005l.99.633.613-.618-.633-.982a.501.501 0 0 1-.007-.531 4.76 4.76 0 0 0 .57-1.367.502.502 0 0 1 .378-.372l1.139-.253v-.857l-1.139-.253a.502.502 0 0 1-.378-.372 4.788 4.788 0 0 0-.57-1.367.497.497 0 0 1 .006-.53l.634-.991-.612-.612-.991.634a.498.498 0 0 1-.529.005 4.815 4.815 0 0 0-1.367-.571.498.498 0 0 1-.371-.38L23.937 14H23.5a.5.5 0 0 1 0-1h.84a.5.5 0 0 1 .488.395l.267 1.233c.366.111.725.261 1.071.448l1.074-.687a.5.5 0 0 1 .623.068l1.181 1.18a.5.5 0 0 1 .067.623l-.687 1.074c.187.347.337.706.448 1.073l1.235.274a.5.5 0 0 1 .392.488v1.66a.5.5 0 0 1-.392.488l-1.235.274a5.767 5.767 0 0 1-.448 1.072l.686 1.064a.498.498 0 0 1-.065.623l-1.181 1.19a.5.5 0 0 1-.624.069l-1.074-.687a5.815 5.815 0 0 1-1.071.448l-.267 1.233a.5.5 0 0 1-.488.397z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M24.553 22.768a.5.5 0 0 1-.211-.953A2.01 2.01 0 0 0 25.5 20a2.002 2.002 0 0 0-2.777-1.843.5.5 0 1 1-.39-.92A3.004 3.004 0 0 1 26.5 20a3.011 3.011 0 0 1-1.736 2.721.498.498 0 0 1-.211.047zM26 10h-6c-1.103 0-2-.897-2-2s.897-2 2-2h6c1.103 0 2 .897 2 2s-.897 2-2 2zm-6-3a1.001 1.001 0 0 0 0 2h6a1.001 1.001 0 0 0 0-2z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Patient-Centric Design</h2>
                            <p>
                              Every patient's needs are carefully considered,
                              ensuring a personalized experience.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "opticalCharRec" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Optical Character Recognition</h2>
                      <p>
                        Transform Your Data with Advanced OCR & Image Processing
                        Solutions
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>OCR</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h3>Elevate Your Digital Transformation Journey</h3>
                      <p>
                        Unlock the full potential of your digital assets with
                        our state-of-the-art Optical Character Recognition (OCR)
                        and Image Processing services. From automating data
                        entry to enhancing image quality, our solutions are
                        designed to streamline your operations and unlock
                        valuable insights hidden in your images and documents.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Benefits of OCR & Image Processing</h2>
                      <ul>
                        <li>
                          <strong>1. Efficiency and Speed:</strong> Automate the
                          extraction of text from images and documents,
                          significantly reducing manual data entry efforts.
                        </li>
                        <li>
                          <strong>2. Accuracy and Reliability:</strong> Leverage
                          advanced algorithms to ensure high accuracy in text
                          recognition and image analysis.
                        </li>
                        <li>
                          <strong>3. Accessibility:</strong> Convert scanned
                          documents into editable and searchable formats,
                          improving information accessibility.
                        </li>
                        <li>
                          <strong>4. Enhanced Image Quality:</strong> Improve
                          image content for analysis and presentation through
                          noise reduction, color correction, and more.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Tools We Use</h2>
                      <ul>
                        <li>
                          <strong>1. Tesseract OCR:</strong> An open-source
                          engine renowned for its accuracy in recognizing text
                          across multiple languages.
                        </li>
                        <li>
                          <strong>2. OpenCV:</strong>Tailored strategies that
                          fit your unique business requirements and challenges.
                        </li>
                        <li>
                          <strong>3. Adobe Sensei:</strong> Dedicated
                          professionals with deep expertise in AI, logistics,
                          and fleet management.
                        </li>
                        <li>
                          <strong>4. ABBYY FineReader:</strong> Comprehensive
                          after-sales support and continuous improvement of
                          deployed solutions.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img
                        src={opticalCharRecImg3}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Cutting-Edge Technology:</strong> Our
                          solutions leverage the latest in OCR and image
                          processing technologies.
                        </li>
                        <li>
                          <strong>2. Tailored Solutions:</strong>We customize
                          our approach to meet your specific business needs and
                          challenges.
                        </li>
                        <li>
                          <strong>3. Expert Team:</strong> Our specialists
                          possess deep expertise in AI, machine learning, and
                          computer vision
                        </li>
                        <li>
                          <strong>4. Comprehensive Support:</strong> From
                          initial consultation to post-deployment, we offer
                          unwavering support and maintenance
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Industries</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#6cdc99"
                                      opacity="1"
                                      data-original="#6cdc99"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h120.091"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 100.223)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M0 0h120.091"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 152.538)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M0 0h245.881"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 260.111)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M0 0h245.881"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 335.247)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M0 0h216.095"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 410.383)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="M0 0h135.844"
                                  transform="matrix(1.33333 0 0 -1.33333 139.67 485.52)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.45"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h-88.588c-10.115 0-18.315 8.2-18.315 18.315v88.588"
                                    transform="translate(409.566 397.597)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c-24.472 0-44.31 19.838-44.31 44.309 0 24.472 19.838 44.31 44.31 44.31s44.31-19.838 44.31-44.31C44.31 19.838 24.472 0 0 0Zm83.574 61.145v0a11.71 11.71 0 0 0-11.077 7.941 75.987 75.987 0 0 1-3.703 8.936c-2.214 4.511-1.349 9.924 2.204 13.477L71 91.5c4.569 4.57 4.569 11.978 0 16.547l-7.262 7.262c-4.569 4.569-11.977 4.569-16.547 0l-.002-.002c-3.552-3.553-8.966-4.417-13.476-2.203a76.172 76.172 0 0 1-8.937 3.703 11.71 11.71 0 0 0-7.941 11.076c0 6.462-5.238 11.7-11.7 11.7h-10.27c-6.462 0-11.7-5.238-11.7-11.7a11.71 11.71 0 0 0-7.941-11.076 76.172 76.172 0 0 1-8.937-3.703c-4.511-2.214-9.924-1.35-13.476 2.203l-.002.002c-4.57 4.569-11.978 4.569-16.547 0L-71 108.047c-4.569-4.569-4.569-11.977 0-16.547l.002-.001c3.553-3.553 4.418-8.966 2.203-13.477a76.152 76.152 0 0 1-3.702-8.936 11.712 11.712 0 0 0-11.077-7.941c-6.462 0-11.7-5.239-11.7-11.701v-10.27c0-6.462 5.238-11.7 11.7-11.7 5.012 0 9.456-3.198 11.077-7.941a76.081 76.081 0 0 1 3.702-8.936c2.215-4.511 1.35-9.924-2.203-13.477L-71-2.882c-4.569-4.569-4.569-11.977 0-16.547l7.262-7.261c4.569-4.57 11.977-4.57 16.547 0l.002.002c3.552 3.552 8.965 4.417 13.476 2.203a76.001 76.001 0 0 1 8.937-3.703c4.743-1.621 7.941-6.064 7.941-11.077 0-6.462 5.238-11.7 11.7-11.7h10.27c6.462 0 11.7 5.238 11.7 11.7 0 5.013 3.198 9.456 7.941 11.077a76.001 76.001 0 0 1 8.937 3.703c4.51 2.214 9.924 1.349 13.476-2.203l.002-.002c4.57-4.57 11.978-4.57 16.547 0L71-19.429c4.569 4.57 4.569 11.978 0 16.547l-.002.002C67.445.673 66.58 6.086 68.794 10.597a75.916 75.916 0 0 1 3.703 8.936c1.621 4.743 6.064 7.941 11.077 7.941 6.462 0 11.7 5.238 11.7 11.7v10.27c0 6.462-5.238 11.701-11.7 11.701z"
                                    transform="translate(365.157 58.465)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v190.347L-106.903 297.25h-226.854c-13.388 0-24.241-10.853-24.241-24.24v-406.602c0-13.387 10.853-24.24 24.241-24.24H-157.9"
                                    transform="translate(409.566 207.25)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Document Management</h2>
                            <p>
                              Digitize archives, automate invoice processing,
                              and manage contracts efficiently.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 68 68"
                            >
                              <g>
                                <path
                                  d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                                  fill="#67a9d5"
                                  opacity="1"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                                  fill="#67a9d5"
                                  opacity="0.45"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                                  fill="#67a9d5"
                                  opacity="0.45"
                                  data-original="#67a9d5"
                                ></path>
                                <path
                                  d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                                  fill="#67a9d5"
                                  opacity="0.45"
                                  data-original="#67a9d5"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Healthcare</h2>
                            <p>
                              Extract patient information from ID cards and
                              process medical images for diagnostics.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                                <path
                                  d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Banking & Finance</h2>
                            <p>
                              Automate form processing, check verification, and
                              financial document management.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#e2e283"
                                      opacity="0.35"
                                      data-original="#e2e283"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h141.485l27.006 90.369H-12.757"
                                  transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                                  fill="none"
                                  stroke="#e2e283"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#e2e283"
                                  opacity="0.35"
                                ></path>
                                <path
                                  d="M0 0h-131.957l-20.668 160.11h-37.587"
                                  transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                                  fill="none"
                                  stroke="#e2e283"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#e2e283"
                                  opacity="0.35"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(242.644 162.873)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(332.929 162.889)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                    transform="translate(376.413 10)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                  ></path>
                                  <path
                                    d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                    transform="translate(414.606 89.832)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                  ></path>
                                  <path
                                    d="M0 0h13.333"
                                    transform="translate(249.333 49.916)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h94.979"
                                    transform="translate(208.51 462.447)"
                                    fill="none"
                                    stroke="#e2e283"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#e2e283"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Retail & E-commerce</h2>
                            <p>
                              Enhance product images and automate the extraction
                              of information from supplier invoices.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How accurate is OCR technology?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Modern OCR solutions achieve high accuracy levels,
                              especially on clear, well-formatted documents.
                              Accuracy can vary with the quality of the source
                              material.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Can image processing improve old or damaged
                            documents?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, image processing techniques can significantly
                              enhance the readability of old or damaged
                              documents, making them suitable for OCR.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Are your solutions scalable?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. Our OCR and image processing solutions
                              can scale to meet the needs of any organization,
                              from small businesses to large enterprises.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>
                        Ready to Unlock the Value in Your Images and Documents?
                      </h2>
                      <p>
                        Unlock the true value of your images and documents with
                        HummingTec's advanced OCR and Image Processing
                        solutions. Our cutting-edge technology transforms your
                        data processing and image analysis operations, enabling
                        seamless extraction, automation, and intelligent
                        insights. Contact us today to discover how we can help
                        your business optimize workflows, improve accuracy, and
                        drive efficiency with customized, scalable solutions
                        tailored to your unique needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>
                              Streamlining Operations for a Logistics Company
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Manual processing of
                              shipping documents was slow and error-prone.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented an OCR
                              system for automatic document processing.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 70% reduction in
                              processing time and significant error reduction.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Enhancing Diagnostic Accuracy in Healthcare</h2>
                            <p>
                              <strong>Challenge:</strong>Improve the quality of
                              medical imaging for better diagnostic outcomes.{" "}
                            </p>
                            <p>
                              <strong>Solution:</strong> Deployed advanced image
                              processing algorithms for medical images.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Enhanced image clarity
                              led to more accurate diagnoses and treatment
                              plans.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "aiDrivenIn" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>AI-Driven Insights for Competitive Edge</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap aiDrivenWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>AI-Driven Insights for Competitive Edge</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap aiDrivenIntro">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <ul>
                        <li>
                          1. Harness the power of Artificial Intelligence to
                          analyze vast datasets, identify patterns, and predict
                          outcomes with high accuracy.
                        </li>
                        <li>
                          2. Our AI-driven approach transforms raw data into
                          actionable insights, giving your business a
                          competitive edge.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap marTp0">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>
                        Benefits of Our Prediction and Load Forecasting Service
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 481.954 481"
                            >
                              <g>
                                <path
                                  d="M296.879 206.594a7.995 7.995 0 0 0 10.484.508l54.059-42.579 67.59 52.532-34.59 2.468a8 8 0 0 0-7.43 8.262 7.996 7.996 0 0 0 8.57 7.7l55.348-3.954a8.005 8.005 0 0 0 7.406-8.594l-3.953-51.394c-.34-4.406-4.187-7.703-8.59-7.363a7.999 7.999 0 0 0-7.363 8.59l2.563 33.316L366.3 148.05a7.995 7.995 0 0 0-9.86.031l-53.5 42.145-51.644-49.54a8.003 8.003 0 0 0-11.317.231 8.008 8.008 0 0 0 .23 11.32zM473.953 424.035H436v-94.258c0-4.418-3.922-7.742-8.34-7.742h-77.219c-4.418 0-8.441 3.324-8.441 7.742v94.258h-49V257.582c0-4.418-3.848-7.547-8.266-7.547h-77.218a7.238 7.238 0 0 0-5.418 2.121 7.211 7.211 0 0 0-2.098 5.426v166.453h-50V218.816a7.986 7.986 0 0 0-2.48-5.59 8.003 8.003 0 0 0-5.711-2.19h-77.22a7.503 7.503 0 0 0-5.472 2.253A7.482 7.482 0 0 0 57 218.816v205.22H16V57.03a8 8 0 0 0-16 0v374.567c0 4.422 3.629 8.437 8.047 8.437h465.906a8 8 0 0 0 0-16zm-400.953 0v-197h61v197zm143 0v-158h61v158zm142 0v-86h62v86zm0 0"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M130.156 138.129a8.192 8.192 0 0 0-1.156-.094c-.266 0-.535.016-.8.043-8.134-.777-14.348-7.61-14.36-15.781a8 8 0 0 0-16 0c.02 14.238 9.469 26.738 23.16 30.64v7.098c0 4.422 3.582 8 8 8s8-3.578 8-8v-6.738c15.738-3.707 26.203-18.621 24.332-34.68-1.867-16.062-15.469-28.176-31.64-28.176-8.758 0-15.856-7.097-15.856-15.855s7.098-15.856 15.855-15.856c8.758 0 15.856 7.102 15.856 15.86a8 8 0 0 0 16 0c-.02-15.156-10.695-28.207-25.547-31.227v-7.328a8 8 0 0 0-16 0v8.211c-14.957 4.774-24.207 19.734-21.79 35.25 2.419 15.512 15.782 26.953 31.481 26.95 8.66.003 15.711 6.956 15.84 15.613.125 8.66-6.722 15.816-15.375 16.074zm0 0"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M129.691 197.535c54.418 0 98.532-44.113 98.532-98.527 0-54.418-44.114-98.531-98.532-98.531s-98.53 44.113-98.53 98.53c.062 54.391 44.14 98.47 98.53 98.528zm0-181.058c45.582 0 82.532 36.949 82.532 82.53 0 45.579-36.95 82.528-82.532 82.528-45.578 0-82.53-36.95-82.53-82.527.05-45.559 36.972-82.48 82.53-82.531zm0 0"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Cost Reduction</h2>
                            <p>
                              Efficient resource management and demand
                              prediction lead to significant cost savings.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#9ccdee"
                                      opacity="1"
                                      data-original="#9ccdee"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="m0 0-143.317-143.317a51.975 51.975 0 0 0-22.176-13.137l-21.293-6.219c-13.975-4.083-26.944 8.887-22.862 22.862l6.22 21.293a51.97 51.97 0 0 0 13.136 22.175L-46.975 46.974c10.053 10.053 26.351 10.053 36.404 0L0 36.403C10.052 26.351 10.052 10.052 0 0Z"
                                    transform="translate(476.935 170.936)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h184.152"
                                    transform="translate(91.374 58.05)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="M0 0c-4.59 17.667-20.646 30.709-39.75 30.709h-268.692c-22.681 0-41.066-18.386-41.066-41.066v-364.317c0-18.408 12.111-33.987 28.799-39.204"
                                    transform="translate(377.034 473.79)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="M0 0v272.039"
                                    transform="translate(378.351 166.301)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="m0 0 23.452 23.451"
                                    transform="translate(346.183 87.159)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="M0 0c0-14.007-11.355-25.362-25.362-25.362-14.006 0-25.361 11.355-25.361 25.362 0 14.007 11.355 25.361 25.361 25.361C-11.355 25.361 0 14.007 0 0Z"
                                    transform="translate(136.355 154.488)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h121.859"
                                    transform="translate(191.387 154.488)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c0-14.007-11.355-25.361-25.362-25.361-14.006 0-25.361 11.354-25.361 25.361 0 14.007 11.355 25.362 25.361 25.362C-11.355 25.362 0 14.007 0 0Z"
                                    transform="translate(136.355 249.286)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h121.859"
                                    transform="translate(191.387 249.286)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h121.859"
                                    transform="translate(191.387 344.084)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 17.62-17.62 44.142 44.142"
                                    transform="translate(80.112 346.115)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h-152.338c-10.995 0-19.908 8.914-19.908 19.909v17.327c0 10.995 8.913 19.909 19.908 19.909H0c10.995 0 19.908-8.914 19.908-19.909V19.909C19.908 8.914 10.995 0 0 0Z"
                                    transform="translate(279.107 412.548)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="m0 0-43.846 43.846"
                                    transform="translate(321.503 18.633)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="m0 0 46.975-46.974"
                                    transform="translate(406.396 194.346)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="m0 0-46.974 46.975"
                                    transform="translate(424.767 118.768)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Improved Resource Planning</h2>
                            <p>
                              Anticipate and respond to market changes
                              effectively, ensuring optimal resource
                              utilization.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 511"
                            >
                              <g>
                                <path
                                  d="M499.5 29.61H472a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h25v405.288H110a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h389.5c6.895 0 12.5-5.609 12.5-12.5V42.11c0-6.894-5.605-12.5-12.5-12.5zM74 449.898H15V44.61h80.566c1.13 1.383 2.606 2.598 4.395 3.57l39.355 21.438c5.196 2.832 13.582 4.969 19.508 4.969h244.219c8.809 0 15.98-7.156 15.98-15.953V44.609H437a7.5 7.5 0 0 0 7.5-7.5c0-4.144-3.355-7.5-7.5-7.5h-17.977V16.45c0-8.793-7.168-15.949-15.98-15.949H158.824c-5.926 0-14.312 2.137-19.508 4.969L99.957 26.902c-1.402.766-2.617 1.68-3.621 2.707H12.5C5.605 29.61 0 35.215 0 42.11V452.4c0 6.89 5.605 12.5 12.5 12.5H74a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5zM369.844 15.5h33.199c.523 0 .98.445.98.95v42.183c0 .508-.457.953-.98.953h-33.2zm-200.102 0h185.102v14.543H169.742zm0 29.543h185.102v14.543H169.742zM137.5 23.535l8.992-4.894c2.004-1.094 5.274-2.118 8.25-2.684v43.172c-2.976-.566-6.246-1.594-8.254-2.684l-8.988-4.894zm-15 8.172v11.672l-10.715-5.836zm0 0"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M255.992 425.516c28.32 0 52.973-18.332 61.344-45.618a7.5 7.5 0 0 0-4.969-9.367 7.498 7.498 0 0 0-9.37 4.969c-6.427 20.941-25.313 35.016-47.005 35.016-27.14 0-49.219-22.34-49.219-49.801 0-27.461 22.079-49.8 49.22-49.8 20.847 0 39.503 13.358 46.425 33.245 1.36 3.914 5.637 5.985 9.547 4.617a7.498 7.498 0 0 0 4.62-9.547c-9.019-25.91-33.366-43.316-60.593-43.316-35.41 0-64.219 29.066-64.219 64.8 0 35.731 28.809 64.802 64.22 64.802zm0 0"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M239.344 352.21v-5.897c0-4.145-3.356-7.5-7.5-7.5s-7.5 3.355-7.5 7.5v5.898c0 4.144 3.355 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5zM287.633 352.21v-5.897c0-4.145-3.356-7.5-7.5-7.5a7.497 7.497 0 0 0-7.5 7.5v5.898c0 4.144 3.355 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5zM239.363 386.82h33.25c4.145 0 7.5-3.355 7.5-7.5a7.5 7.5 0 0 0-7.5-7.5h-33.25a7.5 7.5 0 0 0-7.5 7.5c0 4.145 3.356 7.5 7.5 7.5zM113.445 425.516c35.407 0 64.211-29.07 64.211-64.801 0-35.735-28.804-64.805-64.21-64.805-35.41 0-64.216 29.07-64.216 64.805 0 35.73 28.805 64.8 64.215 64.8zm0-114.606c27.137 0 49.211 22.344 49.211 49.805 0 27.457-22.074 49.8-49.21 49.8-27.137 0-49.216-22.343-49.216-49.8 0-27.461 22.079-49.805 49.215-49.805zm0 0"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M89.3 359.71c4.145 0 7.5-3.355 7.5-7.5v-5.897c0-4.145-3.355-7.5-7.5-7.5a7.5 7.5 0 0 0-7.5 7.5v5.898c0 4.14 3.36 7.5 7.5 7.5zM137.59 359.71a7.5 7.5 0 0 0 7.5-7.5v-5.897a7.5 7.5 0 0 0-7.5-7.5 7.497 7.497 0 0 0-7.5 7.5v5.898a7.5 7.5 0 0 0 7.5 7.5zM87.89 374.414c0 13.098 11.465 23.754 25.56 23.754 14.09 0 25.554-10.656 25.554-23.754a7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-7.5 7.5c0 4.828-4.734 8.754-10.555 8.754-5.824 0-10.558-3.926-10.558-8.754a7.5 7.5 0 1 0-15 0zM398.555 425.516c35.41 0 64.215-29.07 64.215-64.801 0-35.735-28.805-64.805-64.215-64.805-35.407 0-64.211 29.07-64.211 64.805 0 35.73 28.804 64.8 64.21 64.8zm0-114.606c27.136 0 49.215 22.344 49.215 49.805 0 27.457-22.079 49.8-49.215 49.8-27.133 0-49.211-22.343-49.211-49.8 0-27.461 22.078-49.805 49.21-49.805zm0 0"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M374.41 359.71c4.145 0 7.5-3.355 7.5-7.5v-5.897c0-4.145-3.355-7.5-7.5-7.5a7.5 7.5 0 0 0-7.5 7.5v5.898c0 4.14 3.36 7.5 7.5 7.5zM422.703 359.71c4.145 0 7.5-3.355 7.5-7.5v-5.897c0-4.145-3.355-7.5-7.5-7.5s-7.5 3.355-7.5 7.5v5.898a7.5 7.5 0 0 0 7.5 7.5zM373 387.46c0 4.145 3.355 7.5 7.5 7.5a7.5 7.5 0 0 0 7.5-7.5c0-4.823 4.734-8.75 10.555-8.75 5.824 0 10.562 3.927 10.562 8.75 0 4.145 3.356 7.5 7.5 7.5 4.145 0 7.5-3.355 7.5-7.5 0-13.097-11.469-23.75-25.562-23.75-14.09 0-25.555 10.653-25.555 23.75zM59.73 173.46h51.997c5.789 0 10.5-4.706 10.5-10.5v-43.292l2.957-2.977a7.497 7.497 0 0 0-5.512-12.777c-1.926-2.234-4.77-3.656-7.945-3.656H59.73c-5.792 0-10.5 4.707-10.5 10.5v52.207c0 5.789 4.708 10.496 10.5 10.496zm4.5-58.206h41.239L87.074 133.78l-6.058-6.105a7.5 7.5 0 0 0-10.649 10.566l9.266 9.336c1.98 2 4.62 3.102 7.437 3.102h.004c2.817 0 5.453-1.098 7.434-3.094l12.719-12.809v23.684H64.23zM145.797 132.078h89.36c4.144 0 7.5-3.355 7.5-7.5s-3.356-7.5-7.5-7.5h-89.36a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5zM145.797 156.64h50.887a7.5 7.5 0 0 0 7.5-7.5c0-4.144-3.356-7.5-7.5-7.5h-50.887a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5zM49.23 258.219c0 5.789 4.708 10.5 10.5 10.5h51.997c5.789 0 10.5-4.711 10.5-10.5v-52.207c0-5.79-4.711-10.5-10.5-10.5H59.73c-5.792 0-10.5 4.71-10.5 10.5zm15-47.707h42.997v43.203H64.23zM145.797 227.336h89.36a7.5 7.5 0 0 0 7.5-7.5c0-4.145-3.356-7.5-7.5-7.5h-89.36a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5zM204.184 244.395c0-4.145-3.356-7.5-7.5-7.5h-50.887a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h50.887c4.14 0 7.5-3.36 7.5-7.5zM279.844 173.46h51.996c5.789 0 10.5-4.706 10.5-10.5v-52.206c0-5.79-4.711-10.5-10.5-10.5h-51.996c-5.793 0-10.5 4.71-10.5 10.5v52.207c0 5.793 4.707 10.5 10.5 10.5zm4.5-58.206h42.996v43.207h-42.996zM358.406 124.578a7.5 7.5 0 0 0 7.5 7.5h89.364c4.14 0 7.5-3.355 7.5-7.5s-3.36-7.5-7.5-7.5h-89.364a7.5 7.5 0 0 0-7.5 7.5zM365.906 156.64h50.89c4.142 0 7.5-3.359 7.5-7.5a7.5 7.5 0 0 0-7.5-7.5h-50.89a7.5 7.5 0 1 0 0 15zM342.34 258.219v-52.207c0-5.79-4.711-10.5-10.5-10.5h-51.996c-5.793 0-10.5 4.71-10.5 10.5v52.207c0 5.789 4.707 10.5 10.5 10.5h51.996c5.789 0 10.5-4.711 10.5-10.5zm-15-4.5h-42.996v-43.207h42.996zM455.27 212.336h-89.36a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h89.36a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5zM416.797 251.895a7.5 7.5 0 1 0 0-15h-50.89a7.5 7.5 0 1 0 0 15zm0 0"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Enhanced Customer Satisfaction</h2>
                            <p>
                              Meet customer demands proactively, improving
                              service and satisfaction.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M39.3 53.5h-1.5v-5h1.5v-2h-5v2h1.5v5h-1.5v2h5zM26.75 55.5l.44-2h2.62l.44 2h2.05l-1.83-8.22a.997.997 0 0 0-.98-.78h-2c-.47 0-.87.33-.98.78l-1.83 8.22h2.05zm1.56-7h.4l.67 3h-1.73l.67-3z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M32 63c6.62 0 12-5.38 12-12s-5.38-12-12-12-12 5.38-12 12 5.38 12 12 12zm0-22c5.51 0 10 4.49 10 10s-4.49 10-10 10-10-4.49-10-10 4.49-10 10-10zM46 50h17v2H46zM1 50h17v2H1zM12 48V26c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v22h2V27h4v21zM28 37V17c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v23h2V18h4v19zM43 22h-6c-.55 0-1 .45-1 1v15h2V24h4v16h2V23c0-.55-.45-1-1-1zM60 48V12c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v36h2V13h4v35z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M40 12c-.92 0-1.73.42-2.28 1.08L27 9.06v-.05c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 .18.02.34.05.51L9.96 15.76c-.53-.46-1.21-.75-1.96-.75-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.18-.02-.34-.05-.51l11.09-6.24c.53.46 1.21.75 1.96.75.92 0 1.73-.42 2.28-1.08L37 14.95V15c0 1.65 1.35 3 3 3s3-1.35 3-3c0-.27-.05-.52-.11-.77l11.35-7.81c.5.36 1.1.58 1.76.58 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .27.05.52.11.77l-11.35 7.81c-.5-.36-1.1-.58-1.76-.58zM8 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm16-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm16 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM56 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data-Driven Strategies</h2>
                            <p>
                              Make strategic decisions based on robust data
                              analysis and predictive modeling.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugItroWrap staffAugValueWrap aiDrivenInsdustWrap">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="imgWrap">
                      <img src={aboutImg} class="img-fluid" alt="" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="dataWrap">
                      <h2>Industries We Serve</h2>
                      <ul>
                        <li>
                          <span>1. Energy and Utilities:</span>
                          Predict energy consumption patterns and optimize grid
                          management.
                        </li>
                        <li>
                          <span>2. Retail:</span>
                          Forecast consumer buying trends and manage inventory
                          efficiently.
                        </li>
                        <li>
                          <span>3. Logistics and Supply Chain:</span>
                          Anticipate demand surges and optimize supply chain
                          operations.
                        </li>
                        <li>
                          <span>4. End-to-End Support:</span>
                          Continuous optimization and maintenance
                        </li>
                        <li>
                          <span>5. Manufacturing:</span>
                          Plan production schedules based on accurate demand
                          forecasts.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "generativeAi" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Generative AI in Garment Design</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>Generative AI in Garment Design</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        Welcome to the future of fashion design at Hummingtec,
                        where our Generative AI technology is revolutionizing
                        the garment design process. We blend the latest in
                        artificial intelligence with the art of fashion, opening
                        up a world of unparalleled creativity and innovation.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={GenerativeAIIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Innovative Design at Your Fingertips</h2>
                              <ul>
                                <li>
                                  Our Generative AI technology is a game-changer
                                  for fashion designers, brands, and retailers.
                                  It uses advanced algorithms to create unique,
                                  trend-setting garment designs.
                                </li>
                                <li>
                                  From conceptual sketches to detailed patterns,
                                  our AI tools offer an array of design
                                  possibilities that push creative boundaries.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={GenerativeAIIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Customization and Personalization</h2>
                              <ul>
                                <li>
                                  Tailor your designs to specific demographics,
                                  trends, or even individual preferences. Our AI
                                  system adapts to various styles, fabrics, and
                                  color palettes, offering personalized design
                                  solutions.
                                </li>
                                <li>
                                  Stay ahead in the fast-paced fashion industry
                                  with designs that cater to evolving consumer
                                  tastes and market trends.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={GenerativeAIIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>
                                Efficiency and Speed in Design Development
                              </h2>
                              <ul>
                                <li>
                                  Rapidly generate and iterate design concepts,
                                  significantly reducing the time from ideation
                                  to final product.
                                </li>
                                <li>
                                  Our AI-driven process streamlines workflow,
                                  allowing designers to focus on refining and
                                  perfecting unique garment designs.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={GenerativeAIIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Sustainable and Ethical Fashion</h2>
                              <ul>
                                <li>
                                  Contribute to sustainable fashion by using our
                                  AI to optimize material usage and reduce waste
                                  in the design process.
                                </li>
                                <li>
                                  Embrace ethical design practices with AI that
                                  helps in making informed decisions on fabric
                                  selection and production techniques.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>The Power of AI in Garment Design</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#9ceebd"
                                      opacity="1"
                                      data-original="#9ceebd"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0v-128.867"
                                  transform="matrix(1.33333 0 0 -1.33333 623.706 142.678)"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="15"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="15, 15, 15, 15, 350"
                                  stroke-dashoffset="0"
                                  data-original="#9ceebd"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h44.5c13.84 0 25.06 11.22 25.06 25.061V73.55h-497V25.061C-427.44 11.22-416.22 0-402.38 0H-15"
                                    transform="translate(434.94 126.84)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M0 0h-44.5c-13.84 0-25.06-11.221-25.06-25.061v-265.28h497v265.28C427.44-11.221 416.22 0 402.38 0H15"
                                    transform="translate(77.06 490.73)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M0 0h-133.734l12.459 62.267h108.816z"
                                    transform="translate(322.867 64.574)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M372.898 21.27H139.102v43.305h233.796z"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M263.5 156.113h-15v15h15z"
                                    fill="#9ceebd"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M107.05 268.33H60.13v61.12h46.92zM107.05 200.391H60.13v67.939h46.92z"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h-57.95l10 131.111H-10Z"
                                    transform="translate(217.975 200.386)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M328.322 200.386H265.92v161.111h62.402z"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0-30.128-40.483 14.666-39.546h30.924l14.667 39.546zM0 0v-40.015"
                                    transform="translate(82.462 409.483)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c-.494-19.606-16.789-35.102-36.396-34.607-19.608.494-35.102 16.79-34.608 36.396 0 0-2.152 51.05 37.118 63.239 0 0 7.637-20.279 21.085-33.499C-4.396 23.267.369 11.999.007.218z"
                                    transform="translate(224.176 366.122)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h26.414"
                                    transform="translate(265.92 328.503)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h35.08"
                                    transform="translate(265.92 296)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h26.414"
                                    transform="translate(265.92 263.497)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h35.08"
                                    transform="translate(265.92 230.993)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v166.901l-21.698 35.532-21.695-35.529V0Z"
                                    transform="translate(421 200.216)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v-18.56a34.654 34.654 0 0 0-21.699-7.585 34.652 34.652 0 0 0-21.694 7.585V0l21.694 35.531z"
                                    transform="translate(421 367.118)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="15"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Enhanced Creativity</h2>
                            <p>
                              Unlock new creative potentials with AI-generated
                              designs that inspire.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 128 128"
                            >
                              <g>
                                <path
                                  d="M108.142 73.975a2.002 2.002 0 0 1 4.003 0v48.027a5.963 5.963 0 0 1-1.764 4.229l-.006.01a5.985 5.985 0 0 1-4.232 1.76H28.841a5.975 5.975 0 0 1-4.239-1.76 2.935 2.935 0 0 1-.123-.133 5.984 5.984 0 0 1-1.639-4.106V79.475a2 2 0 0 1 4 0v42.526c0 .516.193.987.512 1.339a.886.886 0 0 1 .077.073c.362.362.864.587 1.412.587h77.302c.549 0 1.049-.222 1.412-.581l.006-.006c.359-.362.58-.864.58-1.412zM26.84 16.704a2 2 0 0 1-4 0V6.001c0-1.645.676-3.142 1.764-4.233l.003-.003.003-.003.006-.006A5.977 5.977 0 0 1 28.842 0h77.303c1.645 0 3.145.675 4.234 1.766l.004-.003a5.972 5.972 0 0 1 1.763 4.239v32.6a2 2 0 1 1-4.003 0v-32.6c0-.548-.225-1.049-.586-1.412l.002-.003-.002-.006A1.994 1.994 0 0 0 106.145 4H28.842c-.554 0-1.052.224-1.412.58l-.006.009c-.36.356-.583.857-.583 1.411zM24.842 23.221c6.859 0 13.069 2.783 17.564 7.278s7.277 10.705 7.277 17.564-2.782 13.069-7.277 17.564c-4.495 4.498-10.705 7.277-17.564 7.277s-13.068-2.779-17.564-7.277C2.779 61.132 0 54.921 0 48.063s2.779-13.069 7.277-17.564a24.764 24.764 0 0 1 17.565-7.278zM39.58 33.325a20.787 20.787 0 0 0-14.738-6.102 20.78 20.78 0 0 0-14.738 6.102A20.79 20.79 0 0 0 4 48.063a20.78 20.78 0 0 0 6.104 14.738 20.782 20.782 0 0 0 14.738 6.104 20.79 20.79 0 0 0 14.738-6.104 20.777 20.777 0 0 0 6.102-14.738 20.787 20.787 0 0 0-6.102-14.738z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M24.842 23.221a24.735 24.735 0 0 1 14.021 4.339 24.934 24.934 0 0 1 9.148 11.552 1.992 1.992 0 0 1-1.141 2.576l-21.311 8.236a1.993 1.993 0 0 1-2.578-1.141 1.98 1.98 0 0 1-.137-.719h-.004v-22.84c0-1.107.896-2.003 2.002-2.003zm11.769 7.637a20.681 20.681 0 0 0-9.771-3.54v17.835l16.643-6.432a20.92 20.92 0 0 0-6.872-7.863z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M48.013 39.111a24.894 24.894 0 0 1 1.4 12.606 24.577 24.577 0 0 1-.808 3.566 1.989 1.989 0 0 1-2.482 1.329L24.265 49.97a1.995 1.995 0 0 1-1.329-2.485 1.987 1.987 0 0 1 1.188-1.279v-.003l21.311-8.232a1.99 1.99 0 0 1 2.578 1.14zm-2.677 5.117a19.864 19.864 0 0 0-.415-1.786l-13.968 5.397 14.324 4.354c.068-.345.13-.695.184-1.055.146-.99.221-2.019.221-3.074 0-1.334-.119-2.616-.346-3.836zM12.227 101.981a1.998 1.998 0 1 1-1.953-3.485l31.102-17.419a1.994 1.994 0 0 1 2.49.436l5.637 5.859 27.91-18.295a1.997 1.997 0 0 1 2.727.519l5.938 7.242 38.698-30.348a1.996 1.996 0 0 1 2.797.345 1.995 1.995 0 0 1-.345 2.797L87 81.181h-.004a1.99 1.99 0 0 1-2.764-.304l-6.129-7.475-27.797 18.222v-.003a1.994 1.994 0 0 1-2.528-.286l-5.795-6.022z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M39.028 126.001a2 2 0 0 1-4 0V85.799a1.999 1.999 0 0 1 4 0zM47.214 89.953a2 2 0 1 1 3.999 0v36.048a2 2 0 0 1-3.999 0zM63.398 126.001a2 2 0 0 1-4 0V81.963a2 2 0 0 1 4 0zM71.587 73.975a2 2 0 1 1 4 0v52.026a2 2 0 0 1-4 0zM87.771 126.001a2 2 0 0 1-4 0V79.613c0-1.105.896-2.002 1.999-2.002 1.105 0 2.001.896 2.001 2.002zM95.957 70.055a2 2 0 0 1 4 0v55.946a2 2 0 0 1-4 0zM113.634 48.546a1.995 1.995 0 0 1-1.742-2.226 1.998 1.998 0 0 1 2.226-1.742l12.126 1.5a1.999 1.999 0 0 1 1.742 2.225l-.009.074-1.397 12.005a1.997 1.997 0 1 1-3.968-.451l1.177-10.127zM62.645 16.671a2 2 0 1 1 0 4H60.67a2 2 0 0 1 0-4zM62.645 26.112a1.999 1.999 0 1 1 0 4H60.67a2 2 0 0 1 0-4zM62.645 35.55a2.001 2.001 0 0 1 0 4H60.67a1.999 1.999 0 0 1 0-4zM89.676 16.671c1.105 0 2.002.896 2.002 1.999a2.001 2.001 0 0 1-2.002 2.001H72.492a2 2 0 0 1 0-4zM99.941 26.112a2 2 0 1 1 0 4H72.492a2 2 0 0 1 0-4zM81.311 35.55a2 2 0 1 1 0 4h-8.818a2 2 0 0 1 0-4z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data-Driven Decisions</h2>
                            <p>
                              Utilize market and trend data to inform design
                              choices, ensuring relevance and appeal.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 495.062 495.062"
                            >
                              <g>
                                <path
                                  d="M489.794 473.136a17.763 17.763 0 0 0-13.304-13.304v-12.64c-.043-15.889-11.562-29.42-27.24-32V22.552h22.56a4 4 0 0 0 0-8H318.65c-1.862-9.72-11.251-16.091-20.971-14.229a17.92 17.92 0 0 0-14.229 14.229H179.77c-1.862-9.72-11.251-16.091-20.971-14.229a17.92 17.92 0 0 0-14.229 14.229H23.331a4 4 0 0 0 0 8h22.56v392.64c-15.678 2.58-27.197 16.111-27.24 32v12.64c-9.602 2.209-15.595 11.784-13.386 21.386s11.784 15.595 21.386 13.386c9.602-2.209 15.595-11.784 13.386-21.386a17.84 17.84 0 0 0-13.386-13.386v-12.72c.022-13.511 10.969-24.458 24.48-24.48h392.88c13.511.022 24.458 10.969 24.48 24.48v12.72c-9.557 2.209-15.513 11.747-13.304 21.304 2.209 9.557 11.747 15.513 21.304 13.304 9.556-2.21 15.513-11.748 13.303-21.304zm-457.463 4.056c.066 5.434-4.285 9.893-9.719 9.959-5.434.066-9.893-4.285-9.959-9.719s4.285-9.893 9.719-9.959l.159-.001a9.8 9.8 0 0 1 9.8 9.72zm268.72-469.24-.04.2a9.88 9.88 0 0 1 9.36 6.4h-18.8a9.88 9.88 0 0 1 9.48-6.6zm-121.48 14.6h130.2a9.92 9.92 0 0 1-8.72 5.28 4 4 0 0 0-4 4v6.48h-20.8a4.837 4.837 0 0 0-1.36.28c-.363.18-.7.408-1 .68h-.24l-25.04 29.4-7.68 2.64a46.842 46.842 0 0 0-24.36-18.68l-18.84-6.24h-.96a3.34 3.34 0 0 0-.6 0h-30v-10.92a17.959 17.959 0 0 0 13.4-12.92zm153.72 55.96v.12a4 4 0 0 0 4.84 2.92l19.2-4.68 13.28 6.24c-1.64 12.4-8.44 62.64-13.08 87.04a157.867 157.867 0 0 0-1.96 32.44h-20l-.28-46.6v-.28a4.01 4.01 0 0 0-.24-1v-.44l-12.32-25.52 32-22.44a4 4 0 0 0 1.68-3.24 4.002 4.002 0 0 0-1.64-3.28l-35.2-25.04 13.2-25.36 17.68 20.8-14.28 3.48a4 4 0 0 0-2.88 4.84zm43.72 16.96c8.68 23.28 25.8 82 36.32 202.52h-18.8l-27.28-136.68c3.44-20.44 7.48-49.08 9.76-65.84zm-20.28 129.12c0 1.04 0 2.04.28 3.12 1.24 12 25.84 120 31.32 144l-51.68 3.76-.88-150.88h20.96zm-21.16-8.12v-5.88h20c.24 1.92.36 3.92.52 5.88h-20.52zm-227.28-103.84a4 4 0 0 0-4 4v24.6l-29.44-3.28 9.6-47.04a38.8 38.8 0 0 1 26.12-30.24l14-4.64c2.959 20.755 22.183 35.181 42.938 32.222 16.71-2.382 29.84-15.512 32.222-32.222l14 4.64a38.718 38.718 0 0 1 19.04 13.8l-7.08 2.44a3.998 3.998 0 0 0-2.16 1.8c-1.04 1.76-22.28 40.44-37.28 165.72h-73.96v-127.8a4 4 0 0 0-4-4zm24.16-58h59.4c-2.175 16.403-17.236 27.937-33.638 25.762-13.422-1.78-23.982-12.34-25.762-25.762zm92.64 40.84c2.48 16.8 6.48 45.44 9.8 65.8l-27.32 136.52h-18.76c10.48-120.16 27.64-179.08 36.28-202.32zm6.48-12 19.28-6.8 19.44 4.76a4 4 0 1 0 1.88-7.759l-14.28-3.48 17.68-20.64 12.4 25.64-34.44 24.6a4 4 0 0 0-1.68 3.28 4 4 0 0 0 1.72 3.24l74 51.8v44.48h-80.84a161.094 161.094 0 0 0-2.12-32.56c-4.64-24.201-11.32-73.721-13.04-86.561zm89.48 60.48-58.4-40.96 28.92-20.48 29.48 61.44zm-13.48-46.2 8.32-15.84 29.48 21.08-26.28 18.44-11.52-23.68zm20.12 118.72h-81.64c0-1.96.28-4 .36-5.88h81.16l.12 5.88zm-82.6 11v.24c0-1.08 0-2.08.28-3.12h82.4l.92 155.68-114.88-8.8c5.48-24 30.04-131.8 31.28-144zm58.2-138.68-20.52-42.48h14.28v4.32a4 4 0 0 0 8 0v-4.32h20.36l-22.12 42.48zm-141.12-80.84-.04.2a9.878 9.878 0 0 1 9.44 6.4h-18.72a9.959 9.959 0 0 1 9.32-6.6zm279.08 406.72H53.891v-392l116.96.08a9.92 9.92 0 0 1-8.72 5.28 4 4 0 0 0-4 4v14.8h-30a3.34 3.34 0 0 0-.6 0h-.64l-18.84 6.24a46.8 46.8 0 0 0-31.48 36.32l-10.44 51.24a4 4 0 0 0 .68 3.16 4 4 0 0 0 2.8 1.6l34.68 4v99.04a4 4 0 0 0 4 4h77.04c-1.76 15.04-3.36 31.4-4.88 49a4 4 0 0 0 4 4.36h26.4a4.001 4.001 0 0 0 4-3.24l23.6-117.84a250.758 250.758 0 0 1-1.24 42.08c-1.04 10.28-21.52 100.92-32 147.4a3.999 3.999 0 0 0 .68 3.28 4.002 4.002 0 0 0 2.92 1.64l124 9.36h.56a4.533 4.533 0 0 0 1.28-.28l.48-.28c.16-.133.307-.28.44-.44.142-.143.263-.304.36-.48.196-.214.358-.457.48-.72a3.36 3.36 0 0 0 0-.68 2.864 2.864 0 0 0 0-.68v-1.44l56.84-4.28a4 4 0 0 0 3.6-4.92c-10.68-46.48-31.12-137.12-32.2-147.4a250.328 250.328 0 0 1-1.2-42.08l23.56 117.84a4.001 4.001 0 0 0 4 3.24h26.44a4 4 0 0 0 4-4.36c-14.52-170.92-41.88-220.68-43.04-222.72a4 4 0 0 0-1.8-1.64l-16.56-7.8-25.2-29.56a6.006 6.006 0 0 0-1.04-.72 5.104 5.104 0 0 0-1.36-.28h-27.4v-3.32a17.92 17.92 0 0 0 13.24-12.8h122.96v392zm41.16 62.52c-.022 5.412-4.428 9.782-9.84 9.76-5.412-.022-9.782-4.428-9.76-9.84a9.8 9.8 0 0 1 9.8-9.76c5.412 0 9.8 4.388 9.8 9.8v.04z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M318.451 160.432h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8zM318.451 242.312h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8zM318.451 293.632h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8zM288.531 160.432h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8zM288.531 242.312h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8zM288.531 293.632h-4.72a4 4 0 0 0 0 8h4.72a4 4 0 0 0 0-8z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Reduced Time-to-Market</h2>
                            <p>
                              Accelerate the design process, from initial
                              concept to ready-to-wear garments.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 1707 1707"
                            >
                              <g>
                                <path
                                  d="M715 1625h-4c-371-68-641-392-641-771 0-349 234-659 570-754 25-7 36 32 11 39-318 90-541 384-541 715 0 359 256 667 609 731 23 5 20 40-4 40zm346-16c-23 0-28-33-5-39 318-90 541-384 541-716 0-359-256-666-609-731-26-5-19-44 7-39 372 68 642 392 642 770 0 349-235 659-570 754-2 1-4 1-6 1z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M564 300c-16 0-25-17-18-30l79-136c3-6 1-14-5-18L484 37c-23-13-3-47 20-34l136 78c25 15 34 48 19 73l-78 136c-4 6-10 10-17 10zM1212 1707c-12 0-126-70-146-81-25-15-34-48-19-73l78-136c13-23 48-3 35 20l-79 136c-3 6-1 14 5 18l136 78c18 11 11 38-10 38zM853 544c-93 0-179-58-213-146-9-24 28-39 38-14 59 158 288 162 351 0 9-25 47-10 37 14-33 88-119 146-213 146z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M1121 1338H586c-29 0-52-24-52-52V803l-89 100c-7 8-20 9-28 1L267 772c-8-6-9-18-4-26l123-189c26-49 61-89 105-120 59-41 122-59 164-66 27-4 33 36 7 40-95 16-190 67-241 165L306 753l123 108 110-124c12-13 35-5 35 14v535c0 6 5 12 12 12h535c6 0 12-6 12-12V751c0-19 23-27 35-14l110 124 123-108-115-177c-51-98-147-149-242-165-26-5-19-44 7-40 43 7 106 25 164 66 45 31 80 71 106 120l122 189c6 8 4 19-3 26l-151 132c-8 7-20 7-28-1l-88-100v482c0 29-24 53-52 53z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M1222 848c-19 0-27-22-14-35l159-141c20-18 47 12 27 30l-159 141c-4 3-9 5-13 5zM859 430c-66 0-134-7-204-19-25-5-18-44 7-39 134 24 262 24 382 0 25-6 33 34 8 39-63 12-127 19-193 19zM973 921c-63 0-107-40-107-97V710c0-11 9-20 20-20h164c11 0 20 9 20 20v114c0 53-43 97-97 97zm-67-191v94c0 76 124 76 124 0v-94z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M1050 801H886c-27 0-27-40 0-40h164c27 0 27 40 0 40zM485 848c-5 0-10-2-13-5L312 702c-19-18 7-48 27-30l159 141c14 12 5 35-13 35z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Sustainability Focus</h2>
                            <p>
                              Promote sustainable fashion with AI that optimizes
                              for material usage and eco-friendly practices.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "digitalHealth" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Digital Health Assistant</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>Digital Health Assistant</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <div className="titleWrap sticyDiv">
                      <p>
                        Welcome to a new era of personalized healthcare with
                        Hummingtec's Digital Health Assistant. Our innovative
                        platform is revolutionizing the way individuals manage
                        their health and wellness, offering a blend of
                        convenience, intelligence, and personalized care.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="masonaryWrap">
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                      >
                        <Masonry>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco1}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Your Personal Health Companion</h2>
                              <p>
                                Our Digital Health Assistant is designed to be
                                your personal health and wellness companion,
                                available 24/7. It offers tailored health
                                advice, tracks your wellness journey, and
                                provides proactive health management tips.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco2}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>AI-Powered Health Insights</h2>
                              <p>
                                Utilizing advanced AI algorithms, our Digital
                                Health Assistant analyzes your health data to
                                provide personalized recommendations. From
                                nutrition advice to exercise tips, it
                                understands your unique health profile and
                                guides you towards healthier choices.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco3}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Seamless Integration with Wearables</h2>
                              <p>
                                Connect with various wearables and health
                                devices for real-time health monitoring. Our
                                system integrates data from your devices to
                                track vital health metrics like heart rate,
                                sleep patterns, and physical activity.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco4}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Medication and Appointment Reminders</h2>
                              <p>
                                Stay on top of your health regimen with
                                medication reminders and appointment alerts. Our
                                Digital Health Assistant ensures you never miss
                                a dose or a doctor's visit.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco5}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Interactive Health Education</h2>
                              <p>
                                Gain valuable health insights through
                                interactive educational content. Learn about
                                healthy living, disease prevention, and wellness
                                tips tailored to your interests and needs.
                              </p>
                            </div>
                          </div>
                          <div className="itemWrap">
                            <div className="icoWrap">
                              <img
                                src={DigitalHealthIco6}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Confidential and Secure</h2>
                              <p>
                                Your health information is confidential and
                                secure with us. We prioritize data security and
                                privacy, ensuring your personal health data is
                                protected and handled with the utmost care.
                              </p>
                            </div>
                          </div>
                        </Masonry>
                      </ResponsiveMasonry>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Benefits of Hummingtec's Digital Health Assistant</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 32 32"
                            >
                              <g>
                                <path
                                  d="M23.5 9C22.121 9 21 7.879 21 6.5S22.121 4 23.5 4 26 5.121 26 6.5 24.879 9 23.5 9zm0-4c-.827 0-1.5.673-1.5 1.5S22.673 8 23.5 8 25 7.327 25 6.5 24.327 5 23.5 5zM28 14a.5.5 0 0 1-.5-.5c0-1.379-1.121-2.5-2.5-2.5h-3a2.502 2.502 0 0 0-2.5 2.5.5.5 0 0 1-1 0c0-1.93 1.57-3.5 3.5-3.5h3c1.93 0 3.5 1.57 3.5 3.5a.5.5 0 0 1-.5.5z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M22.5 17a.5.5 0 0 1-.416-.777l2-3A.501.501 0 0 1 24.5 13h5c.275 0 .5-.225.5-.5v-10c0-.275-.225-.5-.5-.5h-12c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5h4a.5.5 0 0 1 0 1h-4c-.827 0-1.5-.673-1.5-1.5v-10c0-.827.673-1.5 1.5-1.5h12c.827 0 1.5.673 1.5 1.5v10c0 .827-.673 1.5-1.5 1.5h-4.732l-1.852 2.777A.5.5 0 0 1 22.5 17zM28.5 31h-25A2.502 2.502 0 0 1 1 28.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1H2.086c.206.582.762 1 1.414 1h25c.652 0 1.208-.418 1.414-1H19.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 .5.5c0 1.379-1.121 2.5-2.5 2.5zM3.5 27a.5.5 0 0 1-.5-.5v-16C3 9.673 3.673 9 4.5 9h10a.5.5 0 0 1 0 1h-10c-.275 0-.5.225-.5.5v16a.5.5 0 0 1-.5.5zM28.5 27a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5zM17 23h-2a.5.5 0 0 1-.5-.5v-2h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2v2a.5.5 0 0 1-.5.5zm-1.5-1h1v-2a.5.5 0 0 1 .5-.5h2v-1h-2a.5.5 0 0 1-.5-.5v-2h-1v2a.5.5 0 0 1-.5.5h-2v1h2a.5.5 0 0 1 .5.5z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Personalized Health Recommendations</h2>
                            <p>
                              Get customized health advice based on your unique
                              health profile.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M354 16H158a30.034 30.034 0 0 0-30 30v420a30.034 30.034 0 0 0 30 30h196a30.034 30.034 0 0 0 30-30V46a30.034 30.034 0 0 0-30-30zM224 32h64a8 8 0 0 1 0 16h-64a8 8 0 0 1 0-16zm144 434a14.015 14.015 0 0 1-14 14H158a14.015 14.015 0 0 1-14-14V208h48a8 8 0 0 0 6.456-3.276l9.5-12.979 41.639 48.58a8 8 0 0 0 12.149 0l41.878-48.858H368zm-83.256-304.441a8 8 0 0 0-10.424.807L256.04 180.8l-26.014-29.792a8 8 0 0 0-12.482.538L206.963 166l-1.345-1.569a22.17 22.17 0 0 1 1.151-29.969 22.129 22.129 0 0 1 27.849-2.758l16.611 11.074a8 8 0 0 0 8.875 0l16.611-11.074a22.071 22.071 0 0 1 29 32.729l-6.6 7.7zm3.926 22.763-33 38.5-38.009-44.344 6.893-9.421 25.09 28.734a8 8 0 0 0 11.706.372l19.469-19.63zm79.33-8.855h-50.667l.53-.619A38.071 38.071 0 0 0 267.84 118.4l-12.173 8.115-12.173-8.115a38.071 38.071 0 0 0-50.024 56.453l3.788 4.419L187.941 192H144V46a14.015 14.015 0 0 1 14-14h43.376A23.992 23.992 0 0 0 224 64h64a23.992 23.992 0 0 0 22.624-32H354a14.015 14.015 0 0 1 14 14z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M280 448h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16zM320 448h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="256"
                                  cy="264"
                                  r="8"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <circle
                                  cx="224"
                                  cy="264"
                                  r="8"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <circle
                                  cx="288"
                                  cy="264"
                                  r="8"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <path
                                  d="M280 304a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v16h-24a8 8 0 0 0-8 8h-24a8 8 0 0 0-8 8v56h-8a8 8 0 0 0 0 16h184a8 8 0 0 0 0-16v-48a8 8 0 0 0-8-8h-24v-20a8 8 0 0 0-8-8h-24zm-80 88h-16v-48h16zm32 0h-16v-56h16zm32-76v76h-16v-80h16zm48 36h16v40h-16zm-16-28v68h-16v-68z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Continuous Health Tracking</h2>
                            <p>
                              Monitor your health metrics continuously for
                              better health management.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#cb9cee"
                                      opacity="1"
                                      data-original="#cb9cee"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="m0 0 12.922-29.163a23.146 23.146 0 0 1 21.161-13.768h95.031a23.145 23.145 0 0 1 21.161 13.768L163.197 0Z"
                                    transform="translate(174.401 504.43)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h284.203"
                                    transform="translate(113.898 59.29)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h-24.519c-16.063 0-29.085 13.022-29.085 29.085v438.688c0 16.063 13.022 29.085 29.085 29.085h226.038c16.063 0 29.085-13.022 29.085-29.085V29.085C230.604 13.022 217.582 0 201.519 0H34.667"
                                    transform="translate(167.5 7.57)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h-20.452a5.36 5.36 0 0 0-5.359 5.359v20.452a5.358 5.358 0 0 1-5.359 5.358h-29.373a5.358 5.358 0 0 1-5.359-5.358V5.359A5.359 5.359 0 0 0-71.261 0h-20.452a5.359 5.359 0 0 1-5.359-5.359v-29.374a5.359 5.359 0 0 1 5.359-5.359h20.452a5.359 5.359 0 0 0 5.359-5.359v-20.452a5.359 5.359 0 0 1 5.359-5.359h29.373a5.359 5.359 0 0 1 5.359 5.359v20.452a5.36 5.36 0 0 0 5.359 5.359H0a5.359 5.359 0 0 1 5.359 5.359v29.374A5.359 5.359 0 0 1 0 0Z"
                                    transform="translate(301.856 339.359)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0c-13.697 7.696-29.442 12.179-46.213 12.426-54.137.799-98.944-43.324-98.944-97.467 0-20.374 6.255-39.285 16.943-54.926a7.345 7.345 0 0 0 1.246-4.682c-.704-9.717-3.401-24.432-12.781-33.67-1.916-1.888-.817-5.166 1.852-5.509 10.532-1.354 30.272-1.784 43.843 10.661a3.235 3.235 0 0 0 3.615.509c13.67-6.685 29.134-10.268 45.477-9.823 52.203 1.422 94.334 44.413 94.757 96.633.195 24.192-8.422 46.367-22.834 63.506"
                                    transform="translate(303.68 404.354)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h191"
                                    transform="translate(160.5 178)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h191"
                                    transform="translate(160.5 144.271)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                  <path
                                    d="M0 0h133"
                                    transform="translate(189.5 110.541)"
                                    fill="none"
                                    stroke="#cb9cee"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#cb9cee"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Enhanced Engagement</h2>
                            <p>
                              Interactive tools and reminders keep you engaged
                              and informed about your health.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 68 68"
                            >
                              <g>
                                <path
                                  d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data-Driven Insights</h2>
                            <p>
                              Make informed health decisions with AI-powered
                              insights derived from your health data.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 3876.771 3869.199"
                            >
                              <g>
                                <path
                                  d="M3138.843 3342.596H1094.166c-33.454 0-60.574-27.12-60.574-60.574V230.94c0-33.454 27.12-60.575 60.574-60.575h1480.033c33.454 0 60.575 27.12 60.575 60.575v494.432h504.069c33.454 0 60.574 27.12 60.574 60.575v2496.075c0 33.452-27.12 60.574-60.574 60.574zM1154.74 3221.447h1923.528V846.522h-504.069c-33.454 0-60.574-27.12-60.574-60.575V291.515H1154.74z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M3096.382 829.152 2531.734 274.14c-23.859-23.452-24.188-61.803-.738-85.662s61.801-24.19 85.662-.738l564.648 555.012c23.859 23.452 24.188 61.803.738 85.662-23.456 23.863-61.804 24.186-85.662.738zM2697.754 3698.833H737.929c-33.454 0-60.575-27.12-60.575-60.574V500.266c0-33.454 27.12-60.575 60.575-60.575h356.229c33.454 0 60.574 27.12 60.574 60.575s-27.12 60.575-60.574 60.575H798.503v3016.844h1838.678v-295.663c0-33.454 27.12-60.574 60.574-60.574s60.575 27.12 60.575 60.574v356.237c-.002 33.454-27.122 60.574-60.576 60.574z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                                <path
                                  d="M1687.527 1843.316H1415.02c-33.454 0-60.575-27.12-60.575-60.575v-272.506c0-33.454 27.12-60.575 60.575-60.575h272.506c33.454 0 60.575 27.12 60.575 60.575v272.506c.001 33.456-27.119 60.575-60.574 60.575zm-211.933-121.149h151.357V1570.81h-151.357zM2817.989 1570.81h-875.535c-33.454 0-60.575-27.12-60.575-60.575s27.12-60.575 60.575-60.575h875.535c33.454 0 60.575 27.12 60.575 60.575s-27.121 60.575-60.575 60.575zM2503.01 1843.316h-560.559c-33.454 0-60.575-27.12-60.575-60.575s27.12-60.575 60.575-60.575h560.559c33.454 0 60.575 27.12 60.575 60.575s-27.12 60.575-60.575 60.575zM1687.527 2443.674H1415.02c-33.454 0-60.575-27.12-60.575-60.574v-272.506c0-33.454 27.12-60.574 60.575-60.574h272.506c33.454 0 60.575 27.12 60.575 60.574V2383.1c.001 33.453-27.119 60.574-60.574 60.574zm-211.933-121.149h151.357v-151.357h-151.357zM2817.989 2171.168h-875.535c-33.454 0-60.575-27.12-60.575-60.575 0-33.454 27.12-60.574 60.575-60.574h875.535c33.454 0 60.575 27.12 60.575 60.574-.001 33.455-27.121 60.575-60.575 60.575zM2503.01 2443.674h-560.559c-33.454 0-60.575-27.12-60.575-60.574s27.12-60.574 60.575-60.574h560.559c33.454 0 60.575 27.12 60.575 60.574s-27.12 60.574-60.575 60.574zM1687.527 3044.03H1415.02c-33.454 0-60.575-27.12-60.575-60.574V2710.95c0-33.454 27.12-60.574 60.575-60.574h272.506c33.454 0 60.575 27.12 60.575 60.574v272.506c.001 33.454-27.119 60.574-60.574 60.574zm-211.933-121.149h151.357v-151.357h-151.357zM2817.989 2771.524h-875.535c-33.454 0-60.575-27.121-60.575-60.575s27.12-60.574 60.575-60.574h875.535c33.454 0 60.575 27.12 60.575 60.574s-27.121 60.575-60.575 60.575zM2503.01 3044.03h-560.559c-33.454 0-60.575-27.12-60.575-60.574s27.12-60.575 60.575-60.575h560.559c33.454 0 60.575 27.121 60.575 60.575s-27.12 60.574-60.575 60.574zM1974.649 1236.277h-280.933c-33.454 0-60.574-27.12-60.574-60.575v-136.677h-136.677c-33.454 0-60.575-27.12-60.575-60.575V697.518c0-33.454 27.12-60.575 60.575-60.575h136.677V500.266c0-33.454 27.12-60.575 60.574-60.575h280.933c33.454 0 60.575 27.12 60.575 60.575v136.677H2171.9c33.454 0 60.574 27.12 60.574 60.575v280.933c0 33.454-27.12 60.575-60.574 60.575h-136.677v136.677c0 33.454-27.12 60.574-60.574 60.574zm-60.575-121.149V978.451c0-33.454 27.12-60.575 60.574-60.575h136.677V758.092h-136.677c-33.454 0-60.574-27.12-60.574-60.575V560.841H1754.29v136.677c0 33.454-27.12 60.575-60.575 60.575h-136.677v159.784h136.677c33.454 0 60.575 27.12 60.575 60.575v136.676z"
                                  fill="#ff9393"
                                  opacity="0.45"
                                  data-original="#ff9393"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Easy Access to Health Information</h2>
                            <p>
                              A user-friendly interface provides easy access to
                              your health records and information.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "vehicleRouteOpt" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Digital Health Assistant</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>Vehicle Route Optimization</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Vehicle Route Optimization</h2>
                      <h3>
                        Elevate Your Fleet Efficiency with AI-Powered Vehicle
                        Route Optimization
                      </h3>
                      <span>Navigate the Future with Intelligence</span>
                      <p>
                        In the fast-paced world of logistics and fleet
                        management, efficiency is not just an advantage—it's
                        essential. Our AI-powered Vehicle Route Optimization
                        solutions harness the power of artificial intelligence
                        to revolutionize your fleet operations, ensuring optimal
                        route planning, reduced operational costs, and enhanced
                        customer satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Unleashing the Power of AI in Route Optimization</h2>
                      <p>
                        Our solutions integrate cutting-edge AI technologies
                        with advanced analytics to dynamically plan and optimize
                        vehicle routes. By considering real-time traffic data,
                        weather conditions, delivery windows, and vehicle
                        capacity, we provide unparalleled efficiency and
                        reliability in fleet management.
                      </p>
                      <h3>Key Benefits</h3>
                      <ul>
                        <li>
                          <strong>1. Cost Reduction:</strong> Significantly
                          lower fuel consumption, maintenance costs, and
                          overtime expenses.
                        </li>
                        <li>
                          <strong>2. Increased Productivity:</strong> Maximize
                          deliveries and service calls within the same time
                          frame.
                        </li>
                        <li>
                          <strong>3. Enhanced Customer Experience:</strong>{" "}
                          Improve accuracy in delivery times and service
                          reliability.
                        </li>
                        <li>
                          <strong>4. Sustainability:</strong> Reduce carbon
                          emissions by optimizing route selection and vehicle
                          load.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Innovation:</strong> At the forefront of
                          applying AI technologies in route optimization.
                        </li>
                        <li>
                          <strong>2. Custom Solutions:</strong>Tailored
                          strategies that fit your unique business requirements
                          and challenges.
                        </li>
                        <li>
                          <strong>3. Expert Team:</strong> Dedicated
                          professionals with deep expertise in AI, logistics,
                          and fleet management.
                        </li>
                        <li>
                          <strong>4. Ongoing Support:</strong> Comprehensive
                          after-sales support and continuous improvement of
                          deployed solutions.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Industries</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 66 66"
                            >
                              <g>
                                <path
                                  d="M20.1 18.5c-4.9 0-8.8 3.9-8.8 8.7s4 8.7 8.8 8.7 8.8-3.9 8.8-8.7-3.9-8.7-8.8-8.7zm0 15.5c-3.8 0-6.8-3-6.8-6.7s3.1-6.7 6.8-6.7 6.8 3 6.8 6.7-3 6.7-6.8 6.7z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M65 0H31.2c-.6 0-1 .4-1 1v12.8c-3-1.8-6.5-2.7-10.1-2.7C9 11.1 0 20.1 0 31.1c0 11.2 9.1 20.1 20.1 20.1 11.1 0 20.1-9 20.1-20.1 0-.9-.1-1.9-.2-2.8l5.6-4.1H65c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM7.8 44.4c1.5-3.4 4.9-5.6 8.6-5.6h7.4c3.7 0 7.1 2.2 8.6 5.6-3.4 3.1-7.7 4.8-12.3 4.8s-8.9-1.7-12.3-4.8zm30.4-13.3c0 4.3-1.5 8.4-4.3 11.7-2-3.7-5.8-6.1-10.1-6.1h-7.4c-4.3 0-8.1 2.4-10.1 6.1C3.5 39.6 2 35.5 2 31.1 2 21.1 10.1 13 20.1 13c3.6 0 7.1 1.1 10.1 3.1v7c0 .6.4 1 1 1h3.5l-2.6 7.8c-.1.4 0 .9.4 1.1.3.3.8.3 1.2 0l4.5-3.4zM64 22.2H45.3c-.2 0-.4.1-.6.2L35 29.6l2-6.1c.1-.3.1-.6-.1-.9s-.5-.4-.8-.4h-3.9V2H64z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M35.3 7.4H61c.6 0 1-.4 1-1s-.4-1-1-1H35.3c-.6 0-1 .4-1 1s.4 1 1 1zM35.3 12.9H61c.6 0 1-.4 1-1s-.4-1-1-1H35.3c-.6 0-1 .4-1 1 0 .5.4 1 1 1zM35.3 18.4H61c.6 0 1-.4 1-1s-.4-1-1-1H35.3c-.6 0-1 .4-1 1 0 .5.4 1 1 1zM66 42c0-.6-.4-1-1-1H39c-.6 0-1 .4-1 1v23c0 .6.4 1 1 1h26c.6 0 1-.4 1-1V42zm-2 4.7h-7.5V43H64zM54.5 43v6.6l-1.8-2c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3l-1.8 2V43zm-7 0v3.8H40V43zM40 64V48.7h7.5v3.5c0 .4.3.8.6.9.4.1.8 0 1.1-.3l2.8-3.1 2.8 3.1c.3.3.7.4 1.1.3s.6-.5.6-.9v-3.5H64V64zM33.8 55.6H6.5c-.6 0-1 .4-1 1s.4 1 1 1h27.3c.6 0 1-.4 1-1s-.5-1-1-1zM33.8 61.9H6.5c-.6 0-1 .4-1 1s.4 1 1 1h27.3c.6 0 1-.4 1-1s-.5-1-1-1z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Delivery and Courier Services</h2>
                            <p>
                              Optimize routes for time-critical deliveries and
                              parcel distribution.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 4000 4000"
                            >
                              <g>
                                <path
                                  d="M427.632 565.997v1031.474c0 83.232 67.715 150.947 150.947 150.947h1031.474c83.232 0 150.946-67.715 150.946-150.947v-477.999h465.421c118.58 0 231.525 44.606 318.032 125.603 9.705 9.088 22.054 13.588 34.378 13.588 13.433 0 26.837-5.349 36.74-15.927 18.993-20.283 17.947-52.124-2.339-71.117-105.221-98.52-242.593-152.779-386.811-152.779h-465.421V565.997c0-83.232-67.715-150.947-150.946-150.947H578.578c-83.231.001-150.946 67.715-150.946 150.947zm1232.734 0v1031.474c0 27.748-22.572 50.319-50.314 50.319H578.578c-27.742 0-50.314-22.572-50.314-50.319V565.997c0-27.742 22.572-50.314 50.314-50.314h226.42V893.05c0 27.787 22.529 50.316 50.316 50.316h478.002c27.787 0 50.316-22.529 50.316-50.316V515.684h226.42c27.743 0 50.314 22.571 50.314 50.313zm-754.735-50.313H1283v327.05H905.631z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M930.791 1371.049h-251.58c-27.787 0-50.316 22.529-50.316 50.316s22.529 50.316 50.316 50.316H930.79c27.787 0 50.316-22.529 50.316-50.316s-22.528-50.316-50.315-50.316zM993.683 3207.575h1050.671l-199.43 299.144c-15.415 23.126-9.167 54.364 13.956 69.78a50.072 50.072 0 0 0 27.864 8.451c16.258 0 32.214-7.869 41.91-22.407l251.579-377.369a50.314 50.314 0 0 0 0-55.823l-251.579-377.369c-15.418-23.126-46.662-29.36-69.774-13.956-23.123 15.415-29.371 46.653-13.956 69.779l199.43 299.144H993.683c-256.631 0-465.418-208.79-465.418-465.427 0-256.631 208.787-465.421 465.418-465.421h918.266c27.787 0 50.316-22.526 50.316-50.313s-22.529-50.314-50.316-50.314H993.683c-312.121 0-566.051 253.927-566.051 566.048 0 312.126 253.93 566.053 566.051 566.053z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M3572.368 2075.473c0-416.165-338.576-754.741-754.738-754.741s-754.735 338.576-754.735 754.741c0 362.14 181.062 697.789 332.953 915.596 40.272 57.75 83.687 114.343 127.821 166.961-70.071 13.377-131.223 31.476-179.806 53.453-107.464 48.616-130.021 106.793-130.021 147.037 0 155.568 312.986 226.423 603.789 226.423s603.792-70.854 603.792-226.423c0-40.244-22.557-98.421-130.021-147.037-48.583-21.978-109.738-40.076-179.806-53.453 44.13-52.619 87.545-109.212 127.821-166.961 151.889-217.807 332.951-553.455 332.951-915.596zm-251.579 1283.048c0 11.795-31.054 46.037-127.048 76.579-99.739 31.736-233.31 49.216-376.11 49.216-142.801 0-276.371-17.48-376.108-49.216-95.994-30.542-127.048-64.784-127.048-76.579 0-19.037 71.672-81.554 288.152-111.528 12.615 13.377 25.177 26.345 37.619 38.717 123.83 123.125 162.739 123.125 177.385 123.125s53.555 0 177.385-123.125c12.443-12.372 25.004-25.339 37.619-38.717 216.482 29.972 288.154 92.491 288.154 111.528zm-503.159-53.204c-48.815-27.991-205.367-174.604-354.614-394.136-136.626-200.972-299.489-509.093-299.489-835.707 0-360.675 293.43-654.108 654.103-654.108 360.675 0 654.105 293.433 654.105 654.108 0 326.614-162.863 634.736-299.489 835.707-149.246 219.532-305.801 366.145-354.616 394.136z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M2817.63 1672.947c-235.825 0-427.683 191.858-427.683 427.683s191.858 427.683 427.683 427.683c235.827 0 427.685-191.858 427.685-427.683s-191.858-427.683-427.685-427.683zm0 754.739c-180.338 0-327.05-146.715-327.05-327.055s146.712-327.056 327.05-327.056c180.337 0 327.052 146.715 327.052 327.056s-146.714 327.055-327.052 327.055z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Field Services</h2>
                            <p>
                              Plan efficient service routes for technicians and
                              service providers.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M59.599 30.735a.892.892 0 0 0-.042-.107l-3.126-6.7a5.492 5.492 0 0 0-5.196-3.704h-8.028a3.706 3.706 0 0 0-3.617-4.5H10.58a1 1 0 1 0 0 2h29.01a1.71 1.71 0 0 1 1.677 1.98L38.19 38.158a1 1 0 0 0 1.972.328l2.71-16.262h8.362a3.523 3.523 0 0 1 3.36 2.5l3.124 6.695a5.303 5.303 0 0 1 .256 1.63v6.173a2.602 2.602 0 0 1-2.6 2.6H53.58a5.505 5.505 0 0 0-10.808 0h-18.89a5.503 5.503 0 0 0-10.807 0H10.38a1 1 0 1 0 0 2h2.695a5.505 5.505 0 0 0 10.808 0h18.89c1.122 5.93 9.68 5.941 10.807 0h1.795a4.604 4.604 0 0 0 4.6-4.6c-.093-1.735.285-6.9-.376-8.487zM18.479 46.32a3.5 3.5 0 0 1 0-7 3.5 3.5 0 0 1 0 7zm29.697 0a3.5 3.5 0 0 1 0-7 3.5 3.5 0 0 1 0 7z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M53.191 34.023a2.366 2.366 0 0 0 2.13-3.336l-2.402-5.812a1.888 1.888 0 0 0-1.7-1.052h-6.643a1 1 0 0 0-1 1v8.2a1 1 0 0 0 1 1zm-7.615-8.2h5.573l2.355 5.693a.342.342 0 0 1-.313.507h-7.615zM8.573 22.324l10.8.072a1 1 0 0 0 .013-2L8.58 20.324a1 1 0 0 0-.007 2zM17.385 25.796l-12.399-.072a1 1 0 0 0-.011 2l12.404.072a1 1 0 0 0 .006-2zM15.39 31.195l-6.81-.073a1 1 0 0 0-.011 2l6.81.073a1 1 0 0 0 .011-2z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Transport and Logistics</h2>
                            <p>
                              Enhance route planning for freight, transport, and
                              logistics operations.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 128 128"
                            >
                              <g>
                                <path
                                  d="M62 13H18a6 6 0 0 0-6 6v90a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V19a6 6 0 0 0-6-6zm-30 4h16v2a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2zm32 92a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V19a2 2 0 0 1 2-2h10v2a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6v-2h10a2 2 0 0 1 2 2zM96.51 67.31c.62-.72 15.19-17.68 15.19-29.61 0-9.69-7.33-17.28-16.7-17.28S78.3 28 78.3 37.7c0 11.93 14.57 28.89 15.19 29.61a2 2 0 0 0 3.02 0zM95 24.42c7.24 0 12.7 5.71 12.7 13.28 0 8.37-9 20.56-12.7 25.15-3.66-4.59-12.7-16.78-12.7-25.15 0-7.57 5.46-13.28 12.7-13.28z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M103.25 37.47A8.25 8.25 0 1 0 95 45.71a8.26 8.26 0 0 0 8.25-8.24zm-12.5 0A4.25 4.25 0 1 1 95 41.71a4.26 4.26 0 0 1-4.25-4.24zM119.65 88.51c0-1-.19-3.3-1.35-4.51-2.82-2.9-18.09-6.9-24.12-8.64C83.83 69.5 77.9 66 74 66a2 2 0 0 0 0 4c3 0 10.06 4.27 15.91 7.55-1.9.74-12.18.34-15.62-.17a2 2 0 0 0-.58 4 82.51 82.51 0 0 0 16.29.3 8.08 8.08 0 0 0 4.13-2.17c4.44 1.28 18.17 5 21.27 7.24.21.5.93 7.57.47 8.78a10.82 10.82 0 0 1-.9 1.52 28.27 28.27 0 0 1-3.54.52 9.41 9.41 0 1 0-18.61.14L74 98a2 2 0 0 0 0 4l20.4-.32a9.39 9.39 0 0 0 15.34 0 31.32 31.32 0 0 0 6.83-.9c1.16-.32 2.32-2.41 2.85-3.5.96-1.92.49-6.68.23-8.77zm-17.56 13.14a5.42 5.42 0 1 1 5.42-5.42 5.42 5.42 0 0 1-5.42 5.42z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M74 90a2 2 0 0 0 0-4 2 2 0 1 0 0 4zM86 88a2 2 0 0 0-2-2 2 2 0 1 0 2 2zM81 92a2 2 0 0 0-2-2 2 2 0 1 0 2 2zM40 45.23a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm0 36a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M46.46 58.86 38 67.35l-4.44-4.44a2 2 0 1 0-2.83 2.83l5.85 5.85a2 2 0 0 0 2.83 0l9.9-9.9a2 2 0 0 0-2.83-2.83z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Public Sector</h2>
                            <p>
                              Improve routing for emergency services, waste
                              collection, and public transport.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How does AI enhance route optimization?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              AI analyzes vast amounts of data to predict
                              traffic patterns, identify the fastest routes, and
                              adapt to changes in real-time, far beyond
                              traditional methods.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Can your solution integrate with existing fleet
                            management systems?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. Our solutions are designed for
                              seamless integration with existing fleet
                              management software and telematics systems.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Is AI route optimization cost-effective for small
                            fleets?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, businesses of all sizes can achieve
                              significant savings and efficiency gains, with
                              scalable solutions tailored to your fleet size and
                              needs.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Transform Your Fleet Operations with AI</h2>
                      <p>
                        Embrace the next generation of fleet management with our
                        AI-powered Vehicle Route Optimization solutions. Contact
                        us today to discover how we can help you navigate the
                        future of logistics with intelligence, efficiency, and
                        precision
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>
                              Optimizing Delivery Routes for an E-Commerce Giant
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Managing thousands of
                              daily deliveries with varying priorities.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented a custom
                              AI-powered route optimization system.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 20% improvement in
                              delivery efficiency and a 15% reduction in fuel
                              costs.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>
                              Enhancing Service Call Efficiency for a Utility
                              Provider
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Inefficient scheduling
                              of service calls across a wide geographic area.
                            </p>
                            <p>
                              <strong>Solution:</strong> Deployed an AI-based
                              route planning tool integrated with real-time
                              vehicle tracking.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Increased daily service
                              calls by 25% and reduced travel time by 30%.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "GPTModelTraining" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>GPT Model Training</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>GPT Model Training </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h3>Innovate Your Business with Advanced AI</h3>
                      <p>
                        Dive into the future of artificial intelligence with our
                        bespoke GPT Model Creation and Training services.
                        Leveraging the latest advancements in natural language
                        processing (NLP), our custom GPT models are designed to
                        understand, generate, and interpret human language with
                        unprecedented accuracy and fluency. Transform your data
                        into insights, automate complex tasks, and create
                        interactive AI experiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Why GPT?</h2>
                      <p>
                        Generative Pre-trained Transformer models represent the
                        cutting edge of NLP technology, offering versatile
                        applications from automated content creation to
                        sophisticated chatbots and beyond. Our GPT models are
                        trained on diverse datasets, ensuring they grasp the
                        nuances of language and context, ready to tackle your
                        unique business challenges.
                      </p>
                      <h3>Key Benefits</h3>
                      <ul>
                        <li>
                          <strong>1. Enhanced Efficiency:</strong> Automate
                          routine tasks and customer interactions, freeing up
                          valuable resources.
                        </li>
                        <li>
                          <strong>2. Deep Insights:</strong> Analyze large
                          volumes of text data to uncover trends, sentiments,
                          and actionable insights.
                        </li>
                        <li>
                          <strong>3. Innovative Applications:</strong> Create
                          personalized content, generate code, or build
                          intelligent chatbots tailored to your needs.
                        </li>
                        <li>
                          <strong>4. Scalability:</strong> Our GPT models grow
                          with your business, adapting to new data and evolving
                          requirements.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Tools and Technologies</h2>
                      <ul>
                        <li>
                          <strong>1. OpenAI's GPT-3:</strong> The latest in
                          generative model technology for unparalleled language
                          understanding.
                        </li>
                        <li>
                          <strong>2. Hugging Face Transformers:</strong>A
                          library of pre-trained models to accelerate
                          development and deployment.
                        </li>
                        <li>
                          <strong>3.TensorFlow & PyTorch:</strong> : Leading
                          frameworks for training and fine-tuning your custom
                          GPT models.
                        </li>
                        <li>
                          <strong>4. Cloud AI Platforms:</strong> Leverage cloud
                          computing for scalable model training and deployment.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Expertise:</strong> Our team specializes in
                          AI, machine learning, and NLP, with deep knowledge of
                          GPT model development.
                        </li>
                        <li>
                          <strong>2. Customization:</strong>We tailor GPT models
                          to your specific needs, ensuring they align with your
                          business goals and data.
                        </li>
                        <li>
                          <strong>3. Ethical AI:</strong> We prioritize ethical
                          considerations in AI development, focusing on
                          fairness, transparency, and privacy.
                        </li>
                        <li>
                          <strong>4. Ongoing Support:</strong> Benefit from our
                          comprehensive support, from initial model training to
                          continuous updates and improvements.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap gptBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Sectors</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M8.3 54.36c-.54 0-.97-.43-.97-.97V21.53c0-1.6 1.3-2.91 2.91-2.91h9.41c.54 0 .97.43.97.97s-.43.97-.97.97h-9.41c-.54 0-.97.43-.97.97v31.85c0 .54-.44.98-.97.98zM55.7 54.36c-.54 0-.97-.43-.97-.97V21.53c0-.54-.43-.97-.97-.97h-7.57c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h7.57c1.6 0 2.91 1.3 2.91 2.91v31.85c0 .54-.43.98-.97.98z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M54.11 63.28H9.89c-5.45 0-9.89-4.44-9.89-9.9 0-.54.43-.97.97-.97h62.06c.54 0 .97.43.97.97 0 5.46-4.44 9.9-9.89 9.9zM2 54.35c.48 3.93 3.84 6.99 7.9 6.99h44.21c4.06 0 7.42-3.05 7.9-6.99zM19.64 27.36H8.3c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h11.35c.54 0 .97.43.97.97-.01.53-.44.97-.98.97zM55.7 27.36h-9.51c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h9.51a.97.97 0 0 1 0 1.94z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M46.19 38.46H19.64c-.54 0-.97-.43-.97-.97V1.69c0-.54.43-.97.97-.97h17.41c.54 0 .97.43.97.97s-.43.97-.97.97H20.61v33.86h24.61V10.16c0-.54.43-.97.97-.97s.97.43.97.97V37.5c0 .53-.43.96-.97.96z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M46.19 11.13h-9.14c-.54 0-.97-.43-.97-.97V1.69c0-.39.23-.73.58-.89a.99.99 0 0 1 1.05.18l9.14 8.46c.29.27.39.69.24 1.07-.14.37-.5.62-.9.62zm-8.17-1.94h5.7l-5.7-5.28zM41.09 19.33H24.74c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h16.35c.54 0 .97.43.97.97s-.43.97-.97.97zM41.09 25.94H24.74c-.54 0-.97-.43-.97-.97s.43-.97.97-.97h16.35a.97.97 0 0 1 0 1.94z"
                                  fill="#9ceebd"
                                  opacity="0.45"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Content Generation</h2>
                            <p>
                              Produce high-quality, original content for blogs,
                              reports, and social media.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M59.506 27.903A27.322 27.322 0 0 0 51.47 9.43C46.267 4.226 39.352 1.361 32 1.361c-14.849 0-26.982 11.819-27.505 26.542a6.474 6.474 0 0 0-3.852 5.911v7.262a6.475 6.475 0 0 0 6.468 6.468 4.19 4.19 0 0 0 4.185-4.185V31.53c0-2.167-1.662-3.934-3.775-4.144C8.301 14.559 18.979 4.361 32 4.361c6.552 0 12.713 2.554 17.35 7.191 4.258 4.258 6.75 9.808 7.125 15.835-2.111.212-3.77 1.978-3.77 4.143v11.828c0 2.185 1.688 3.963 3.826 4.148v2.989a6.111 6.111 0 0 1-6.105 6.104h-4.521a4.497 4.497 0 0 0-4.267-3.038h-4.66c-.669 0-1.311.142-1.899.416a4.547 4.547 0 0 0-2.64 4.122c0 1.214.473 2.354 1.33 3.207a4.504 4.504 0 0 0 3.209 1.332h4.66c1.932 0 3.635-1.249 4.27-3.039h4.518c5.021 0 9.105-4.084 9.105-9.104v-3.523a6.473 6.473 0 0 0 3.826-5.898v-7.262c0-2.634-1.586-4.902-3.851-5.909zM8.295 31.53v11.828c0 .653-.531 1.185-1.185 1.185a3.472 3.472 0 0 1-3.468-3.468v-7.262a3.472 3.472 0 0 1 3.468-3.468c.654 0 1.185.532 1.185 1.185zm34.848 26.891a1.546 1.546 0 0 1-1.506 1.219h-4.66c-.41 0-.795-.16-1.089-.454a1.523 1.523 0 0 1-.45-1.085 1.542 1.542 0 0 1 1.539-1.538h4.66c.41 0 .795.159 1.088.453.29.289.45.675.45 1.085.001.11-.011.22-.032.32zm17.214-17.346a3.472 3.472 0 0 1-3.468 3.468 1.186 1.186 0 0 1-1.185-1.185V31.53c0-.653.531-1.185 1.185-1.185a3.472 3.472 0 0 1 3.468 3.468z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M41.713 41.592a6.363 6.363 0 0 0 6.356-6.356V22.285c0-1.694-.662-3.29-1.864-4.492s-2.797-1.864-4.492-1.864H22.287a6.363 6.363 0 0 0-6.356 6.356v12.951a6.363 6.363 0 0 0 6.356 6.356h.119v3.356a3.109 3.109 0 0 0 3.112 3.124 3.05 3.05 0 0 0 2.196-.927l5.583-5.553zm-10.091-2.564-6.042 6.009c-.027.028-.047.049-.104.024-.069-.028-.069-.073-.069-.113v-4.856a1.5 1.5 0 0 0-1.5-1.5h-1.619a3.36 3.36 0 0 1-3.356-3.356V22.285a3.36 3.36 0 0 1 3.356-3.356h19.426c.894 0 1.735.35 2.371.985.636.636.985 1.478.985 2.371v12.951a3.36 3.36 0 0 1-3.356 3.356H32.68c-.397 0-.777.157-1.058.436z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M24.713 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM31.999 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.222 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM39.285 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.994-2.213-2.215-2.213z"
                                  fill="#9ccdee"
                                  opacity="0.35"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Customer Service</h2>
                            <p>
                              Power chatbots and virtual assistants to offer
                              real-time, human-like customer support.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 50 50"
                            >
                              <g>
                                <path
                                  d="M42.2 47.7H8c-.3 0-.5-.2-.5-.5V2.8c0-.3.2-.5.5-.5h34.2c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5s-.5-.2-.5-.5V3.3H8.5v43.3h33.2v-9c0-.3.2-.5.5-.5s.5.2.5.5v9.5c0 .3-.2.6-.5.6z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M8 44.4H4.7c-.3 0-.5-.2-.5-.5V6.1c0-.3.2-.5.5-.5H8c.3 0 .5.2.5.5V44c0 .2-.2.4-.5.4zm-2.8-1h2.2V6.6H5.2z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M4.7 41.7H1.5c-.3 0-.5-.2-.5-.5V8.8c0-.3.2-.5.5-.5h3.2c.3 0 .5.2.5.5v32.4c0 .3-.2.5-.5.5zm-2.7-1h2.2V9.3H2zM17.1 43.7h-3.7c-.3 0-.5-.2-.5-.5v-6.8c0-.3.2-.5.5-.5h3.7c.3 0 .5.2.5.5v6.8c0 .2-.2.5-.5.5zm-3.2-1h2.7v-5.8h-2.7zM23.7 43.7H20c-.3 0-.5-.2-.5-.5v-9.3c0-.3.2-.5.5-.5h3.7c.3 0 .5.2.5.5v9.3c0 .2-.3.5-.5.5zm-3.3-1h2.7v-8.3h-2.7zM30.2 43.7h-3.7c-.3 0-.5-.2-.5-.5v-5.5c0-.3.2-.5.5-.5h3.7c.3 0 .5.2.5.5v5.5c0 .3-.2.5-.5.5zm-3.2-1h2.7v-4.5H27zM36.8 43.7h-3.7c-.3 0-.5-.2-.5-.5V31.6c0-.3.2-.5.5-.5h3.7c.3 0 .5.2.5.5v11.6c0 .3-.2.5-.5.5zm-3.2-1h2.7V32.1h-2.7zM27 15c-.2 0-.3-.1-.4-.2-.2-.2-.1-.5.1-.7l5.6-3.8c.2-.2.5-.1.7.1s.1.5-.1.7l-5.6 3.8c-.1.1-.2.1-.3.1zM16.4 13.5c-.2 0-.3-.1-.4-.2-.2-.2-.1-.5.1-.7l3.3-2.2c.2-.2.5-.1.7.1s.1.5-.1.7l-3.3 2.2c-.1.1-.2.1-.3.1zM24.2 14.7c-.2 0-.3-.1-.4-.2l-2-3c-.2-.2-.1-.5.1-.7s.5-.1.7.1l2 3c.2.2.1.5-.1.7-.1.1-.2.1-.3.1z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M21.2 12.1h-.4c-.6-.1-1.1-.5-1.4-1s-.5-1.1-.3-1.7c.1-.6.5-1.1 1-1.4 1-.7 2.5-.4 3.1.6.3.5.5 1.1.3 1.7-.1.6-.5 1.1-1 1.4-.5.2-.9.4-1.3.4zm-.8-3.4c-.3.2-.5.5-.5.8-.1.3 0 .7.2 1s.5.5.8.5c.3.1.7 0 1-.2s.5-.5.5-.8c.1-.3 0-.7-.2-1-.4-.5-1.2-.7-1.8-.3zM25.5 17.7h-.4c-.6-.1-1.1-.5-1.4-1s-.5-1.1-.3-1.7c.1-.6.5-1.1 1-1.4 1-.7 2.5-.4 3.1.6.7 1 .4 2.5-.6 3.1-.5.3-.9.4-1.4.4zm0-3.6c-.2 0-.5.1-.7.2-.3.2-.5.5-.5.8-.1.3 0 .7.2 1s.5.5.8.5c.3.1.7 0 1-.2.6-.4.7-1.2.3-1.8-.3-.3-.7-.5-1.1-.5zM34.1 12h-.4c-.6-.1-1.1-.5-1.4-1s-.5-1.1-.3-1.7c.1-.6.5-1.1 1-1.4 1-.7 2.5-.4 3.1.6.7 1 .4 2.5-.6 3.1-.5.3-.9.4-1.4.4zm0-3.6c-.2 0-.5.1-.7.2-.3.2-.5.5-.5.8-.1.3 0 .7.2 1s.5.5.8.5c.3.1.7 0 1-.2.6-.4.7-1.2.3-1.8-.3-.3-.7-.5-1.1-.5zM14.9 16h-.4c-.6-.1-1.1-.5-1.4-1s-.5-1.1-.3-1.7c.1-.6.5-1.1 1-1.4.5-.3 1.1-.5 1.7-.3.6.1 1.1.5 1.4 1 .7 1 .4 2.5-.6 3.1-.5.2-1 .3-1.4.3zm0-3.5c-.2 0-.5.1-.7.2-.3.2-.5.5-.5.8-.1.3 0 .7.2 1 .4.6 1.2.7 1.8.3s.7-1.2.3-1.8c-.2-.3-.5-.5-.8-.5h-.3zM25.6 21.5h-5.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.7c.3 0 .5.2.5.5s-.3.5-.5.5zM17.4 21.5h-4.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.2c.3 0 .5.2.5.5s-.2.5-.5.5zM29.1 23.8h-5.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.3c.3 0 .5.2.5.5s-.2.5-.5.5zM21.3 23.8h-8.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8.2c.3 0 .5.2.5.5s-.2.5-.5.5zM25.2 26.1h-4.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.9c.3 0 .5.2.5.5s-.3.5-.5.5zM17.8 26.1h-4.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.6c.3 0 .5.2.5.5s-.3.5-.5.5zM29.1 28.4h-4.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.9c.3 0 .5.2.5.5s-.2.5-.5.5zM21.7 28.4h-8.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8.5c.3 0 .5.2.5.5s-.2.5-.5.5zM18.6 30.7h-5.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.4c.3 0 .5.2.5.5s-.2.5-.5.5zM41.9 32.4c-.2 0-.4-.1-.5-.3l-.9-2.4c-.1-.1 0-.3 0-.4.1-.1.2-.2.3-.2.6-.1 1.2-.3 1.8-.6.1-.1.3-.1.4 0l.3.3.9 2.4v.4l-.3.3-1.9.7c0-.2 0-.2-.1-.2zm-.2-2.6.5 1.4.9-.3-.5-1.4-.9.3z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M45.7 42.6c-.5 0-1-.1-1.5-.4-.8-.4-1.4-1.2-1.7-2.1l-2.2-7.7c-.1-.3.1-.5.3-.6l4.2-1.5c.2-.1.5 0 .6.3l3.3 7.3c.4.8.4 1.8 0 2.7s-1.1 1.5-1.9 1.8c-.3.1-.7.2-1.1.2zm-2.3-2.7c.2.6.6 1.1 1.2 1.4s1.2.3 1.9.1c.6-.2 1.1-.7 1.3-1.3.3-.6.2-1.3 0-1.9l-3.1-6.9-3.3 1.2zM39.5 30.1c-.8 0-1.6-.1-2.3-.3-2.3-.6-4.2-2.1-5.4-4.2s-1.5-4.5-.9-6.8 2.1-4.2 4.2-5.4 4.5-1.5 6.8-.9 4.2 2.1 5.4 4.2 1.5 4.5.9 6.8-2.1 4.2-4.2 5.4c-1.5.8-3 1.2-4.5 1.2zm-.1-16.9c-1.4 0-2.7.4-4 1.1-1.8 1.1-3.2 2.8-3.7 4.8s-.3 4.2.8 6 2.8 3.2 4.8 3.7c2 .6 4.2.3 6-.8s3.2-2.8 3.7-4.8.3-4.2-.8-6-2.8-3.2-4.8-3.7c-.6-.2-1.3-.3-2-.3z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M39.4 27.6c-.4 0-.8 0-1.2-.1-3.5-.7-5.7-4-5.1-7.5.7-3.5 4-5.8 7.5-5.1 1.7.3 3.1 1.3 4.1 2.7s1.3 3.1 1 4.8-1.3 3.1-2.7 4.1c-1 .7-2.3 1.1-3.6 1.1zm-5.3-7.5c-.6 2.9 1.4 5.8 4.3 6.3 1.4.3 2.9 0 4-.8 1.2-.8 2-2 2.3-3.5.3-1.4 0-2.9-.8-4.1s-2-2-3.5-2.3c-2.9-.4-5.7 1.5-6.3 4.4z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Data Analysis</h2>
                            <p>
                              Extract valuable insights from unstructured text
                              data, from market research to customer feedback.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g data-name="10 Translation">
                                <path
                                  d="M37 6h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2ZM32 6h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2ZM32 58a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1ZM38 56h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2ZM24 56h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2ZM18.553 30.9a1 1 0 1 0 .894-1.79 16.156 16.156 0 0 1-2.847-1.834A12.536 12.536 0 0 0 18.786 23H20a1 1 0 0 0 0-2h-4v-1a1 1 0 0 0-2 0v1h-4a1 1 0 0 0 0 2h6.689a10.392 10.392 0 0 1-1.589 2.932 12.47 12.47 0 0 1-1.272-1.488 1 1 0 0 0-1.663 1.111 13.793 13.793 0 0 0 1.541 1.817 9.252 9.252 0 0 1-3.025 1.679 1 1 0 0 0 .632 1.9 11.213 11.213 0 0 0 3.892-2.216 18.3 18.3 0 0 0 3.348 2.165Z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M58 25H47V8a5.006 5.006 0 0 0-5-5H22a5.006 5.006 0 0 0-5 5v7H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h11v21a5.006 5.006 0 0 0 5 5h20a5.006 5.006 0 0 0 5-5V45h11a3 3 0 0 0 3-3V28a3 3 0 0 0-3-3ZM19 8a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v1H19ZM5 32V18a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.59a2.005 2.005 0 0 0 .583 1.41l2 2-2 2A2 2 0 0 0 25 28.41V32a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm40 24a3 3 0 0 1-3 3H22a3 3 0 0 1-3-3v-5h26Zm0-7H19V35h5a3 3 0 0 0 3-3v-3.583l2.71-2.71a1 1 0 0 0 0-1.414L27 21.59V18a3 3 0 0 0-3-3h-5v-4h26v14h-5a3 3 0 0 0-3 3v3.588l-2.7 2.7a1 1 0 0 0 0 1.414L37 38.41V42a3 3 0 0 0 3 3h5Zm14-7a1 1 0 0 1-1 1H40a1 1 0 0 1-1-1v-3.59a2.005 2.005 0 0 0-.583-1.41l-2-2 2-2A2 2 0 0 0 39 31.59V28a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M49.9 29.553a1.042 1.042 0 0 0-1.79 0l-5 10a1 1 0 1 0 1.79.894l4.1-8.211L50.882 36H49a1 1 0 0 0 0 2h2.882l1.223 2.447a1 1 0 0 0 1.79-.894ZM32 17h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2ZM40 19h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2ZM33 19h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2ZM32 39h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2ZM27 43h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2ZM32 43h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Language Translation</h2>
                            <p>
                              Break down language barriers with accurate,
                              context-aware translation services.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            What is required to train a custom GPT model?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Training a custom GPT model requires a dataset
                              relevant to your application, computational
                              resources for training, and expertise in model
                              development and fine-tuning.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How long does it take to train a custom GPT model?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              The time required varies based on the model's
                              complexity and the size of the training dataset,
                              ranging from weeks to months.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can GPT models understand multiple languages?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, GPT models can be trained on multilingual
                              datasets to understand and generate text in
                              multiple languages.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Empower Your Business with Custom GPT Models</h2>
                      <p>
                        Step into the future of AI with our GPT Model Creation
                        and Training services.{" "}
                        <Link to={"/Contact"}>Contact us</Link> today to explore
                        how we can help you leverage the power of advanced
                        natural language processing to achieve your business
                        objectives.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>
                              Revolutionizing Content Creation for a Digital
                              Magazine
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Scaling high-quality,
                              diverse content production.
                            </p>
                            <p>
                              <strong>Solution:</strong>Developed a custom GPT
                              model for automated article generation.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Tripled content output
                              while maintaining quality, driving significant
                              growth in readership.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>
                              Transforming Customer Support for an E-commerce
                              Platform
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Inefficient scheduling
                              of service calls across a wide geographic area.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented a
                              GPT-powered chatbot for instant, accurate customer
                              service.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Improved customer
                              satisfaction by 40% and reduced response times by
                              80%.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "AIChatbots" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>AI Chatbots</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>AI Chatbots</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Unleash the Power of Conversation</h2>
                      <p>
                        In today’s digital-first world, instant, and
                        personalized communication is the key to enhancing
                        customer experience. Our cutting-edge AI chatbot
                        solutions empower your business to engage with customers
                        24/7, providing immediate responses, personalized
                        interactions, and unparalleled service efficiency.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Why AI Chatbots?</h2>
                      <p>
                        AI chatbots are transforming the way businesses interact
                        with their customers. By leveraging natural language
                        processing (NLP) and machine learning (ML), our chatbots
                        can understand and respond to user queries in a
                        human-like manner, automating customer service, sales,
                        and marketing processes.
                      </p>
                      <h3>Tools and Technologies</h3>
                      <ul>
                        <li>
                          <strong>1. Dialogflow:</strong> Develop versatile
                          chatbots with natural language understanding.
                        </li>
                        <li>
                          <strong>2. Microsoft Bot Framework:</strong> Build
                          chatbots with rich multimedia capabilities.
                        </li>
                        <li>
                          <strong>3. IBM Watson:</strong> Create chatbots that
                          learn and adapt from every interaction.
                        </li>
                        <li>
                          <strong>4. Rasa:</strong> Open-source framework for
                          developing sophisticated AI chatbots.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Expertise:</strong> Our team specializes in
                          the latest AI and ML technologies to build intelligent
                          chatbots.
                        </li>
                        <li>
                          <strong>2. Customization:</strong> We tailor chatbot
                          solutions to meet your specific business needs and
                          objectives.
                        </li>
                        <li>
                          <strong>3. Integration:</strong> Seamless integration
                          with your existing CRM, ERP, and other business
                          systems.
                        </li>
                        <li>
                          <strong>4. Support:</strong> Comprehensive support and
                          maintenance to ensure optimal performance.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiChatBotBen">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Industries</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 64 64"
                            >
                              <g>
                                <path
                                  d="M59.506 27.903A27.322 27.322 0 0 0 51.47 9.43C46.267 4.226 39.352 1.361 32 1.361c-14.849 0-26.982 11.819-27.505 26.542a6.474 6.474 0 0 0-3.852 5.911v7.262a6.475 6.475 0 0 0 6.468 6.468 4.19 4.19 0 0 0 4.185-4.185V31.53c0-2.167-1.662-3.934-3.775-4.144C8.301 14.559 18.979 4.361 32 4.361c6.552 0 12.713 2.554 17.35 7.191 4.258 4.258 6.75 9.808 7.125 15.835-2.111.212-3.77 1.978-3.77 4.143v11.828c0 2.185 1.688 3.963 3.826 4.148v2.989a6.111 6.111 0 0 1-6.105 6.104h-4.521a4.497 4.497 0 0 0-4.267-3.038h-4.66c-.669 0-1.311.142-1.899.416a4.547 4.547 0 0 0-2.64 4.122c0 1.214.473 2.354 1.33 3.207a4.504 4.504 0 0 0 3.209 1.332h4.66c1.932 0 3.635-1.249 4.27-3.039h4.518c5.021 0 9.105-4.084 9.105-9.104v-3.523a6.473 6.473 0 0 0 3.826-5.898v-7.262c0-2.634-1.586-4.902-3.851-5.909zM8.295 31.53v11.828c0 .653-.531 1.185-1.185 1.185a3.472 3.472 0 0 1-3.468-3.468v-7.262a3.472 3.472 0 0 1 3.468-3.468c.654 0 1.185.532 1.185 1.185zm34.848 26.891a1.546 1.546 0 0 1-1.506 1.219h-4.66c-.41 0-.795-.16-1.089-.454a1.523 1.523 0 0 1-.45-1.085 1.542 1.542 0 0 1 1.539-1.538h4.66c.41 0 .795.159 1.088.453.29.289.45.675.45 1.085.001.11-.011.22-.032.32zm17.214-17.346a3.472 3.472 0 0 1-3.468 3.468 1.186 1.186 0 0 1-1.185-1.185V31.53c0-.653.531-1.185 1.185-1.185a3.472 3.472 0 0 1 3.468 3.468z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M41.713 41.592a6.363 6.363 0 0 0 6.356-6.356V22.285c0-1.694-.662-3.29-1.864-4.492s-2.797-1.864-4.492-1.864H22.287a6.363 6.363 0 0 0-6.356 6.356v12.951a6.363 6.363 0 0 0 6.356 6.356h.119v3.356a3.109 3.109 0 0 0 3.112 3.124 3.05 3.05 0 0 0 2.196-.927l5.583-5.553zm-10.091-2.564-6.042 6.009c-.027.028-.047.049-.104.024-.069-.028-.069-.073-.069-.113v-4.856a1.5 1.5 0 0 0-1.5-1.5h-1.619a3.36 3.36 0 0 1-3.356-3.356V22.285a3.36 3.36 0 0 1 3.356-3.356h19.426c.894 0 1.735.35 2.371.985.636.636.985 1.478.985 2.371v12.951a3.36 3.36 0 0 1-3.356 3.356H32.68c-.397 0-.777.157-1.058.436z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                                <path
                                  d="M24.713 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM31.999 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.222 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM39.285 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.994-2.213-2.215-2.213z"
                                  fill="#9ceebd"
                                  opacity="0.35"
                                  data-original="#9ceebd"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Customer Support</h2>
                            <p>
                              Provide round-the-clock support, handling FAQs,
                              and troubleshooting.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#9ccdee"
                                      opacity="0.35"
                                      data-original="#9ccdee"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h141.485l27.006 90.369H-12.757"
                                  transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#9ccdee"
                                  opacity="0.35"
                                ></path>
                                <path
                                  d="M0 0h-131.957l-20.668 160.11h-37.587"
                                  transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                                  fill="none"
                                  stroke="#9ccdee"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#9ccdee"
                                  opacity="0.35"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(242.644 162.873)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(332.929 162.889)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                    transform="translate(376.413 10)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                    transform="translate(414.606 89.832)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                  <path
                                    d="M0 0h13.333"
                                    transform="translate(249.333 49.916)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h94.979"
                                    transform="translate(208.51 462.447)"
                                    fill="none"
                                    stroke="#9ccdee"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ccdee"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>E-commerce</h2>
                            <p>
                              Personalize shopping experiences, recommend
                              products, and process orders.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                                <path
                                  d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Banking & Finance</h2>
                            <p>
                              Offer financial advice, account management, and
                              transaction services.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 68 68"
                            >
                              <g>
                                <path
                                  d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                                  fill="#dcdc30"
                                  opacity="0.45"
                                  data-original="#dcdc30"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Healthcare</h2>
                            <p>
                              Schedule appointments, provide health tips, and
                              patient monitoring.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#ff9393"
                                      opacity="1"
                                      data-original="#ff9393"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h177.615c12.042 0 21.803-9.762 21.803-21.803v-67.669"
                                    transform="translate(88.678 504.5)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                  ></path>
                                  <path
                                    d="M0 0c-3.661-6.899-10.917-11.598-19.272-11.598h-236.99c-12.042 0-21.803 9.762-21.803 21.803v453.394c0 12.041 9.761 21.803 21.803 21.803h18.85"
                                    transform="translate(285.565 19.098)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                  ></path>
                                  <path
                                    d="M0 0h-198.833v361.486H81.763v-38.25"
                                    transform="translate(206.333 91.792)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                  ></path>
                                  <path
                                    d="M0 0h-44.385c-6.928 0-12.544 5.616-12.544 12.544 0 6.928 5.616 12.543 12.544 12.543H0c6.928 0 12.543-5.615 12.543-12.543C12.543 5.616 6.928 0 0 0Z"
                                    transform="translate(169.99 37.056)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                  ></path>
                                  <path
                                    d="M0 0c-18.9-7.994-39.68-12.415-61.492-12.415-87.248 0-157.976 70.729-157.976 157.977 0 57.964 31.217 108.637 77.756 136.123"
                                    transform="translate(408.015 19.915)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.25"
                                  ></path>
                                  <path
                                    d="M0 0a159.157 159.157 0 0 0 24.713 1.921c87.248 0 157.977-70.728 157.977-157.976 0-49.6-22.858-93.861-58.615-122.823"
                                    transform="translate(321.81 321.532)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.25"
                                  ></path>
                                  <path
                                    d="m0 0 10.274-9.897 12.014-39.377c3.81-12.491 19.656-16.265 28.687-6.831l31.14 32.523 43.159 3.692a17.087 17.087 0 0 1 14.377 10.598l17.886 44.05c-25.303 52.426-78.716 88.73-140.676 89.376l5.957-52.609-26.447-45.869A21.033 21.033 0 0 1 0 0Z"
                                    transform="translate(331.34 199.299)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.25"
                                  ></path>
                                  <path
                                    d="m0 0-36.247-5.074a19.997 19.997 0 0 0-10.827 1.5l-9.863 4.34A20.001 20.001 0 0 0-68.76 21.281l4.212 37.903a20.002 20.002 0 0 1-5.189 15.782l-48.351 52.326C-144.595 22.032-61.389-77.18 45.975-69.916L21.16-11.937A20 20 0 0 1 0 0Z"
                                    transform="translate(311.647 77.81)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.25"
                                  ></path>
                                  <path
                                    d="m0 0-52.041 46.493 28.941 8.472 79.961-28.799"
                                    transform="translate(267.843 375.677)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 90.818 26.625c16.223 4.75 19.846 26.147 6.051 35.917-17.082 12.097-41.93 21.097-72.515 7.938-60.426-25.996-190.922-88.051-190.922-88.051l-19.049 26.589-18.312-5.361 10.906-37.256c3.404-11.63 15.592-18.298 27.222-14.894l95.51 27.958"
                                    transform="translate(344.46 350.98)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0-22.423-80.36 28.942 8.472 73.237 95.234"
                                    transform="translate(279.727 347.168)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 44.575 12.922a20.355 20.355 0 0 1-5.094 5.163C22.399 30.182-2.448 39.182-33.034 26.023l-.686-.295 4.377-10.428C-25.183 3.212-12.293-3.508 0 0Z"
                                    transform="translate(401.848 395.437)"
                                    fill="none"
                                    stroke="#ff9393"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    opacity="0.45"
                                    stroke-dasharray="none"
                                    data-original="#ff9393"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Travel & Hospitality</h2>
                            <p>
                              Assist with bookings, travel recommendations, and
                              customer service.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How do AI chatbots learn?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Our chatbots improve over time through machine
                              learning, analyzing interactions to provide more
                              accurate responses.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Can chatbots handle multiple languages?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, our chatbots can be designed to support
                              multiple languages, broadening your global reach.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Are AI chatbots secure?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              We prioritize security, implementing encryption
                              and compliance measures to protect your data and
                              privacy.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Get Started with AI Chatbots Today</h2>
                      <p>
                        Embrace the future of customer interaction with our AI
                        chatbot solutions.{" "}
                        <Link to={"/Contact"}>Contact us</Link> to discover how
                        our chatbots can transform your customer engagement,
                        streamline operations, and drive growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Boosting Sales for an E-commerce Giant</h2>
                            <p>
                              <strong>Challenge:</strong> Improve online sales
                              and customer engagement.
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented a product
                              recommendation chatbot.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 30% increase in
                              conversion rates and enhanced customer
                              satisfaction.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>
                              Transforming Customer Service for a Telecom
                              Provider
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Reduce wait times and
                              improve service efficiency.
                            </p>
                            <p>
                              <strong>Solution:</strong> Deployed a customer
                              support chatbot.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 50% reduction in wait
                              times and a significant boost in customer service
                              ratings.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "leadGeneration" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Lead Generation</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>Lead Generation</li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Revolutionize Your Approach to Finding Prospects</h2>
                      <p>
                        Unlock the future of sales and marketing with our
                        AI-powered Lead Generation services. By harnessing
                        advanced artificial intelligence technologies, we
                        empower businesses to identify, engage, and convert
                        high-quality leads more efficiently than ever before.
                        Step into a new era of lead generation where precision
                        meets performance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Why AI-Driven Lead Generation?</h2>
                      <p>
                        Our AI-driven solutions go beyond traditional lead
                        generation methods by analyzing vast datasets to
                        identify patterns and predict customer behavior. This
                        approach not only enhances the quality of leads but also
                        increases conversion rates, ensuring your sales efforts
                        are focused and effective.
                      </p>
                      <h3>Key Benefits</h3>
                      <ul>
                        <li>
                          <strong>1. Improved Lead Quality:</strong> AI
                          algorithms ensure you're targeting prospects with the
                          highest conversion potential.
                        </li>
                        <li>
                          <strong>2. Increased Efficiency:</strong> Automate the
                          lead generation process, freeing up valuable time for
                          your sales team.
                        </li>
                        <li>
                          <strong>3. Data-Driven Insights:</strong> Gain deep
                          insights into customer behavior and preferences to
                          tailor your marketing strategies.
                        </li>
                        <li>
                          <strong>4. Scalability:</strong> Effortlessly scale
                          your lead generation efforts to match your business
                          growth.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Tools and Technologies</h2>
                      <ul>
                        <li>
                          <strong>1. Machine Learning Models:</strong>{" "}
                          Predictive analytics to identify and prioritize leads
                          based on their likelihood to convert.
                        </li>
                        <li>
                          <strong>2. Natural Language Processing (NLP):</strong>
                          Engage with leads through AI-powered chatbots and
                          virtual assistants.
                        </li>
                        <li>
                          <strong>3. Data Mining:</strong> Extract valuable
                          insights from large datasets to inform lead generation
                          strategies.
                        </li>
                        <li>
                          <strong>4. CRM Integration:</strong> Seamlessly
                          connect AI tools with your existing CRM system for a
                          unified sales approach.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Innovation Solutions:</strong> Stay ahead
                          with our cutting-edge AI technologies tailored for
                          lead generation.
                        </li>
                        <li>
                          <strong>2. Expert Team:</strong>Our specialists
                          combine expertise in AI, data science, and marketing
                          to deliver exceptional results.
                        </li>
                        <li>
                          <strong>3. Custom Strategies:</strong> We design
                          personalized lead generation solutions that align with
                          your business goals.
                        </li>
                        <li>
                          <strong>4. Proven Success:</strong> Our track record
                          of transforming lead generation for clients speaks for
                          itself.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Industries</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#9ceebd"
                                      opacity="0.35"
                                      data-original="#9ceebd"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h141.485l27.006 90.369H-12.757"
                                  transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#9ceebd"
                                  opacity="0.35"
                                ></path>
                                <path
                                  d="M0 0h-131.957l-20.668 160.11h-37.587"
                                  transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                                  fill="none"
                                  stroke="#9ceebd"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#9ceebd"
                                  opacity="0.35"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(242.644 162.873)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(332.929 162.889)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                    transform="translate(376.413 10)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                    transform="translate(414.606 89.832)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                  <path
                                    d="M0 0h13.333"
                                    transform="translate(249.333 49.916)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h94.979"
                                    transform="translate(208.51 462.447)"
                                    fill="none"
                                    stroke="#9ceebd"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#9ceebd"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>E-commerce</h2>
                            <p>
                              Enhance customer targeting and personalize
                              marketing campaigns.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 1580 1580"
                            >
                              <g>
                                <path
                                  d="M1534 387.9H46c-13.3 0-24-10.7-24-24s10.7-24 24-24h1488c13.3 0 24 10.7 24 24s-10.7 24-24 24zM1398.9 282.2h-597c-13.3 0-24-10.7-24-24s10.7-24 24-24h597c13.3 0 24 10.7 24 24s-10.8 24-24 24z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <circle
                                  cx="201.4"
                                  cy="258.2"
                                  r="31.6"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <circle
                                  cx="333.7"
                                  cy="258.2"
                                  r="31.6"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <circle
                                  cx="466"
                                  cy="258.2"
                                  r="31.6"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></circle>
                                <path
                                  d="M1474 1451.6H106c-46.3 0-84-37.7-84-84V212.4c0-46.3 37.7-84 84-84h1368c46.3 0 84 37.7 84 84v1155.2c0 46.3-37.7 84-84 84zM106 176.4c-19.9 0-36 16.1-36 36v1155.2c0 19.9 16.1 36 36 36h1368c19.9 0 36-16.1 36-36V212.4c0-19.9-16.1-36-36-36z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M842.7 902.4c-5.4 0-10.9-1.8-15.4-5.6l-77.6-64.7-229.6-191.6-245.3 204.7-62 51.7c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8l77.6-64.7 245.1-204.5c8.9-7.4 21.8-7.4 30.8 0l260.7 217.5 62 51.7c10.2 8.5 11.5 23.6 3.1 33.8-5 5.7-11.8 8.6-18.7 8.6z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M765.2 1206.3H598.8c-13.3 0-24-10.7-24-24V976H465.4v206.3c0 13.3-10.7 24-24 24H275.1c-13.3 0-24-10.7-24-24V813.7c0-13.3 10.7-24 24-24s24 10.7 24 24v344.6h118.3V952c0-13.3 10.7-24 24-24h157.4c13.3 0 24 10.7 24 24v206.3h118.3V813.7c0-13.3 10.7-24 24-24s24 10.7 24 24v368.6c.1 13.2-10.7 24-23.9 24zM1372.5 807.6H990.2c-13.3 0-24-10.7-24-24v-135c0-13.3 10.7-24 24-24h382.3c13.3 0 24 10.7 24 24v135c0 13.2-10.7 24-24 24zm-358.3-48h334.3v-87h-334.3zM1372.5 932.5H990.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h382.3c13.3 0 24 10.7 24 24s-10.7 24-24 24zM1372.5 1049.7H990.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h382.3c13.3 0 24 10.7 24 24s-10.7 24-24 24zM1372.5 1166.9H990.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h382.3c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
                                  fill="#9ccdee"
                                  opacity="0.45"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Real Estate</h2>
                            <p>
                              Identify potential buyers and sellers with
                              precision.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                                <path
                                  d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                                  fill="#cf8fff"
                                  opacity="0.15"
                                  data-original="#cf8fff"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Finance</h2>
                            <p>
                              Generate leads for loan, insurance, and investment
                              products.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#dcdc30"
                                      opacity="1"
                                      data-original="#dcdc30"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0h32.635v-45.96c0-13.662-11.075-24.737-24.737-24.737h-85.493c-13.661 0-24.737 11.075-24.737 24.737V0H-30"
                                    transform="translate(290.852 110.095)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c5.739-18.652 23.104-32.211 43.639-32.211 20.535 0 37.9 13.559 43.639 32.211z"
                                    transform="translate(212.364 39.398)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                  ></path>
                                  <path
                                    d="M0 0c-22.702 0-41.106 18.404-41.106 41.106S-22.702 82.212 0 82.212s41.106-18.404 41.106-41.106S22.702 0 0 0Zm102.26 25.746v30.72l-25.13 3.567a78.898 78.898 0 0 1-9.208 22.229l15.247 20.292-21.721 21.721-20.292-15.247a78.924 78.924 0 0 1-22.23 9.209l-3.566 25.129h-30.72l-3.567-25.129a78.93 78.93 0 0 1-22.229-9.209l-20.292 15.247-21.722-21.721 15.247-20.292a78.957 78.957 0 0 1-9.208-22.229l-25.129-3.567v-30.72l25.129-3.567A78.957 78.957 0 0 1-67.923-.05L-83.17-20.342l21.722-21.721 20.292 15.247a78.93 78.93 0 0 1 22.229-9.209l3.567-25.129h30.72l3.566 25.129a78.924 78.924 0 0 1 22.23 9.209l20.292-15.247 21.721 21.721L67.922-.05a78.93 78.93 0 0 1 9.209 22.229z"
                                    transform="translate(256.003 222.37)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0v43.988"
                                    transform="translate(256 460.825)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h43.989"
                                    transform="translate(436.499 280.325)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h43.989"
                                    transform="translate(31.512 280.325)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 31.105-31.104"
                                    transform="translate(97.263 439.063)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 15.202-5.955"
                                    transform="translate(72.737 352.124)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0-6.129 15.646"
                                    transform="translate(190.157 448.387)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0 6.13 15.646"
                                    transform="translate(321.843 448.387)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0-31.104-31.104"
                                    transform="translate(414.737 439.063)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="m0 0-15.202-5.955"
                                    transform="translate(439.264 352.124)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0c-28.82-27.893-46.859-66.882-46.859-109.778.001-51.887 25.824-97.738 65.317-125.414 12.712-8.91 20.258-23.477 20.258-39v-.004h72.331"
                                    transform="translate(149.804 384.291)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                  ></path>
                                  <path
                                    d="M0 0h32.636c0 15.656 7.763 30.202 20.563 39.219 39.321 27.7 65.01 73.448 65.01 125.201 0 84.096-67.82 152.351-151.75 153.053-30.828.257-59.72-8.816-83.98-24.549"
                                    transform="translate(290.852 110.095)"
                                    fill="none"
                                    stroke="#dcdc30"
                                    stroke-width="15"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#dcdc30"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Technology</h2>
                            <p>
                              Drive B2B lead generation for software and
                              services.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            How does AI improve lead quality?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              AI analyzes historical data and customer
                              interactions to identify the most promising leads,
                              significantly improving targeting accuracy.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Can AI integrate with my existing marketing tools?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Yes, our AI solutions can seamlessly integrate
                              with most marketing tools and platforms, enhancing
                              their capabilities.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Is AI lead generation cost-effective?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. By improving lead quality and
                              conversion rates, AI lead generation ensures a
                              higher ROI on your marketing spend.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Accelerate Your Lead Generation with AI</h2>
                      <p>
                        Ready to redefine your lead generation strategy and
                        drive unprecedented sales growth?{" "}
                        <Link to={"/Contact"}>Contact us</Link> today to explore
                        how our AI-powered solutions can unlock new
                        opportunities for your business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap aimlChatBotCaseStudy">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Case Studies</h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <h2>Boosting Sales for a Tech Startup</h2>
                            <p>
                              <strong>Challenge:</strong> Struggling to identify
                              and convert high-value B2B leads..
                            </p>
                            <p>
                              <strong>Solution:</strong> Implemented a custom
                              AI-powered route optimization system.
                            </p>
                            <p>
                              <strong>Outcome:</strong> 40% increase in lead
                              conversion rates within the first quarter.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg1}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="itemWrap bgClr2">
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>
                              Reimagining Lead Generation for a Financial
                              Services Firm
                            </h2>
                            <p>
                              <strong>Challenge:</strong> Inefficient lead
                              generation processes leading to low conversion
                              rates
                            </p>
                            <p>
                              <strong>Solution:</strong> Deployed an AI-based
                              route planning tool integrated with real-time
                              vehicle tracking.
                            </p>
                            <p>
                              <strong>Outcome:</strong> Doubled the number of
                              qualified leads and reduced customer acquisition
                              costs by 30%.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {initialSection === "forecastingAndPrediction" && (
          <section>
            <div className="topPageBanner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>AI Driven Forecasting and Prediction</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <ul className="bredCrumbsWrap">
                      <li>
                        <Link to="/AIML">AI/ML</Link>
                      </li>
                      <li>AI Driven Forecasting and Prediction </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h3>Navigate the Future with Confidence</h3>
                      <p>
                        In today's data-driven world, making informed decisions
                        is key to staying ahead. Our Prediction, Forecasting,
                        and Analytics services empower your business to predict
                        trends, forecast outcomes, and derive actionable
                        insights from your data. Unlock the power of your data
                        to drive growth, optimize operations, and enhance
                        decision-making processes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadRt">
                      <h2>Why Our Analytics Solutions?</h2>
                      <p>
                        Leverage cutting-edge data science and machine learning
                        technologies to transform complex datasets into clear,
                        actionable insights. Our bespoke analytics solutions are
                        tailored to meet your specific business needs, ensuring
                        you not only keep pace with the market but set the pace.
                      </p>
                      <h3>Key Benefits</h3>
                      <ul>
                        <li>
                          <strong>1. Informed Decision-Making:</strong> Base
                          your strategic decisions on data-driven insights.
                        </li>
                        <li>
                          <strong>2. Future-Ready Strategies: </strong>{" "}
                          Anticipate market trends and customer needs with
                          accurate forecasting.
                        </li>
                        <li>
                          <strong>3. Operational Efficiency:</strong> Identify
                          inefficiencies and optimize processes for better
                          performance.
                        </li>
                        <li>
                          <strong>4. Competitive Advantage: </strong> Stay ahead
                          of the curve by understanding your data at a deeper
                          level.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Tools and Technologies</h2>
                      <ul>
                        <li>
                          <strong>1. Python & R: :</strong> Utilize the leading
                          programming languages for statistical analysis and
                          data visualization.
                        </li>
                        <li>
                          <strong>2. TensorFlow & PyTorch: </strong>Implement
                          machine learning models for predictive analytics.
                        </li>
                        <li>
                          <strong>3.Tableau & Power BI:</strong> : Present data
                          insights through interactive dashboards and reports.
                        </li>
                        <li>
                          <strong>4. SQL & NoSQL Databases:</strong> Manage and
                          query large datasets efficiently.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugItroWrap staffAugValueWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="imgWrap">
                      <img src={aboutImg} className="img-fluid" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="dataWrap dataWrapPadLt">
                      <h2>Why Choose Us?</h2>
                      <ul>
                        <li>
                          <strong>1. Expertise: </strong> Our team consists of
                          data scientists, analysts, and engineers with deep
                          industry knowledge.
                        </li>
                        <li>
                          <strong>2. Customization:</strong>We create tailored
                          analytics solutions that align with your business
                          objectives.
                        </li>
                        <li>
                          <strong>3. Innovation: </strong> Stay at the forefront
                          of technology with our commitment to the latest tools
                          and methodologies.
                        </li>
                        <li>
                          <strong>4. Support:</strong> Benefit from our
                          end-to-end support, ensuring your analytics solutions
                          continue to drive value.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Applications Across Industries</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#6cdc99"
                                      opacity="0.35"
                                      data-original="#6cdc99"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h141.485l27.006 90.369H-12.757"
                                  transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.35"
                                ></path>
                                <path
                                  d="M0 0h-131.957l-20.668 160.11h-37.587"
                                  transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.35"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(242.644 162.873)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(332.929 162.889)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                    transform="translate(376.413 10)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                    transform="translate(414.606 89.832)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h13.333"
                                    transform="translate(249.333 49.916)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h94.979"
                                    transform="translate(208.51 462.447)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Retail</h2>
                            <p>
                              Forecast sales trends, optimize inventory levels,
                              and personalize customer experiences.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                                  fill="#9ccdee"
                                  opacity="0.15"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                                  fill="#9ccdee"
                                  opacity="0.15"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Finance</h2>
                            <p>
                              Predict market movements, assess risk, and
                              automate reporting.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 68 68"
                            >
                              <g>
                                <path
                                  d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Healthcare</h2>
                            <p>
                              Improve patient outcomes with predictive analytics
                              in treatment plans and disease spread.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M266.919 39.825h-20.203M297.609 39.825h0M214.391 39.825h0M104.48 371.85V37.8c0-16.73 13.56-30.3 30.3-30.3h242.44c16.74 0 30.3 13.57 30.3 30.3v33.58M407.52 106.38V474.2c0 16.73-13.56 30.3-30.3 30.3H134.78c-16.74 0-30.3-13.57-30.3-30.3v-67.35"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M326.42 186.66v84.74L256 305.8l-70.42-34.4v-20.81M185.58 215.59v-28.93"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m256 221.057-70.417-34.399 70.417-34.4 70.417 34.4zM256 220.433v84.746M185.583 142.079v-20.211M205.794 142.079h-20.211M325.85 141.462c-17.716-19.032-42.248-33.637-69.85-33.637s-52.134 14.605-69.85 33.637M326.417 142.079v-20.211M306.206 142.079h20.211M336.813 355.683h-96.976M207.512 355.683h-32.325"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <circle
                                  cx="223.675"
                                  cy="355.687"
                                  r="16.163"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M336.813 420.333h-29.446M275.042 420.333h-99.855"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <circle
                                  cx="291.208"
                                  cy="420.338"
                                  r="16.163"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></circle>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Manufacturing</h2>
                            <p>
                              Forecast demand, manage supply chain risks, and
                              optimize production schedules.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="servCaseStudyWrap DrivingConstructWrap">
              <div class="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>
                        Driving Construction Efficiency Through Advanced
                        Forecasting
                      </h2>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <ul>
                      <li>
                        <div class="itemWrap bgClr1">
                          <div className="dataWrap">
                            <p>
                              <strong>Challenge:</strong> A construction company
                              faced significant challenges with project delays
                              and budget overruns due to inefficient resource
                              allocation and unpredictable demand for materials.
                              These issues led to increased costs and reduced
                              client satisfaction.
                            </p>
                            <p>
                              <strong>Solution:</strong> To address these
                              challenges, the construction company implemented a
                              machine learning model to accurately forecast
                              demand for materials and resources. The model
                              utilized historical project data, seasonal trends,
                              and external factors such as market conditions and
                              weather patterns. The forecasting system was
                              integrated into the company's project management
                              software, providing real-time insights and
                              automated alerts for resource needs.
                            </p>
                          </div>
                          <div className="imgWrap">
                            <img
                              src={productsliderImg2}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffOnBoardWrap DrivingConstructStepsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Implementation Steps</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="noWrap">
                            <h2>01</h2>
                          </div>
                          <div className="dataWrap">
                            <h2>Data Collection and Analysis</h2>
                            <p>
                              Gathered historical data on past projects,
                              including material usage, labor hours, weather
                              conditions, and project timelines. This data was
                              cleaned and organized for analysis.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="noWrap">
                            <h2>02</h2>
                          </div>
                          <div className="dataWrap">
                            <h2>Model Development</h2>
                            <p>
                              Developed a machine learning model using
                              algorithms such as linear regression, decision
                              trees, and neural networks. The model was trained
                              on the collected data to identify patterns and
                              correlations.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="noWrap">
                            <h2>03</h2>
                          </div>
                          <div className="dataWrap">
                            <h2>
                              Integration with Project Management Software
                            </h2>
                            <p>
                              {" "}
                              Integrated the forecasting model with the
                              company’s existing project management software.
                              This allowed for real-time updates and automated
                              alerts when forecasted demand deviated from
                              planned resources.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="noWrap">
                            <h2>04</h2>
                          </div>
                          <div className="dataWrap">
                            <h2>Testing and Validation</h2>
                            <p>
                              Conducted extensive testing to validate the
                              model’s accuracy and reliability. Adjustments were
                              made based on feedback and real-world performance.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="noWrap">
                            <h2>05</h2>
                          </div>
                          <div className="dataWrap">
                            <h2>Training and Adoption</h2>
                            <p>
                              {" "}
                              Trained the project management team on using the
                              new forecasting system. Provided ongoing support
                              to ensure smooth adoption and utilization.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="whyHumingtecSec">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>Outcome</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="dataWrap">
                      <p>
                        {" "}
                        The implementation of the advanced forecasting model led
                        to a 25% reduction in project delays and a 15% decrease
                        in budget overruns. The company also achieved a 20%
                        reduction in inventory costs due to more accurate demand
                        predictions. Overall, client satisfaction improved
                        significantly as projects were completed on time and
                        within budget.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="staffAugBenefitsWrap aiPBenefitsWrap DrivingConstructBenefitsWrap">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ttlWrap">
                      <h2>Key Benefits</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ul>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 682.667 682.667"
                            >
                              <g>
                                <defs>
                                  <clipPath
                                    id="a"
                                    clipPathUnits="userSpaceOnUse"
                                  >
                                    <path
                                      d="M0 512h512V0H0Z"
                                      fill="#6cdc99"
                                      opacity="0.35"
                                      data-original="#6cdc99"
                                    ></path>
                                  </clipPath>
                                </defs>
                                <path
                                  d="M0 0h141.485l27.006 90.369H-12.757"
                                  transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.35"
                                ></path>
                                <path
                                  d="M0 0h-131.957l-20.668 160.11h-37.587"
                                  transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                                  fill="none"
                                  stroke="#6cdc99"
                                  stroke-width="20"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  stroke-dasharray="none"
                                  data-original="#6cdc99"
                                  opacity="0.35"
                                ></path>
                                <g
                                  clip-path="url(#a)"
                                  transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                                >
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(242.644 162.873)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                    transform="translate(332.929 162.889)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.35"
                                  ></path>
                                  <path
                                    d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                    transform="translate(376.413 10)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                    transform="translate(414.606 89.832)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                  <path
                                    d="M0 0h13.333"
                                    transform="translate(249.333 49.916)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                    opacity="0.45"
                                  ></path>
                                  <path
                                    d="M0 0h94.979"
                                    transform="translate(208.51 462.447)"
                                    fill="none"
                                    stroke="#6cdc99"
                                    stroke-width="20"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    stroke-dasharray="none"
                                    data-original="#6cdc99"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Improved Resource Allocation</h2>
                            <p>
                              Enabled better planning and allocation of
                              materials and labor, reducing waste and
                              inefficiencies.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                                  fill="#9ccdee"
                                  opacity="1"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                                  fill="#9ccdee"
                                  opacity="0.15"
                                  data-original="#9ccdee"
                                ></path>
                                <path
                                  d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                                  fill="#9ccdee"
                                  opacity="0.15"
                                  data-original="#9ccdee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Enhanced Budget Management</h2>
                            <p>
                              Provided more accurate budget forecasts, helping
                              to control costs and avoid unexpected expenses.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 68 68"
                            >
                              <g>
                                <path
                                  d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                                  fill="#cb9cee"
                                  opacity="1"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                                <path
                                  d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                                  fill="#cb9cee"
                                  opacity="0.45"
                                  data-original="#cb9cee"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Increased Client Satisfaction</h2>
                            <p>
                              Timely project completion and adherence to budget
                              improved client trust and satisfaction.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="itemWrap">
                          <div className="imgWrap">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="62"
                              height="62"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M266.919 39.825h-20.203M297.609 39.825h0M214.391 39.825h0M104.48 371.85V37.8c0-16.73 13.56-30.3 30.3-30.3h242.44c16.74 0 30.3 13.57 30.3 30.3v33.58M407.52 106.38V474.2c0 16.73-13.56 30.3-30.3 30.3H134.78c-16.74 0-30.3-13.57-30.3-30.3v-67.35"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                ></path>
                                <path
                                  d="M326.42 186.66v84.74L256 305.8l-70.42-34.4v-20.81M185.58 215.59v-28.93"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <path
                                  d="m256 221.057-70.417-34.399 70.417-34.4 70.417 34.4zM256 220.433v84.746M185.583 142.079v-20.211M205.794 142.079h-20.211M325.85 141.462c-17.716-19.032-42.248-33.637-69.85-33.637s-52.134 14.605-69.85 33.637M326.417 142.079v-20.211M306.206 142.079h20.211M336.813 355.683h-96.976M207.512 355.683h-32.325"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <circle
                                  cx="223.675"
                                  cy="355.687"
                                  r="16.163"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></circle>
                                <path
                                  d="M336.813 420.333h-29.446M275.042 420.333h-99.855"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></path>
                                <circle
                                  cx="291.208"
                                  cy="420.338"
                                  r="16.163"
                                  fill="none"
                                  stroke="#dcdc30"
                                  stroke-width="15"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-miterlimit="10"
                                  data-original="#dcdc30"
                                  opacity="0.45"
                                ></circle>
                              </g>
                            </svg>
                          </div>
                          <div className="dataWrap">
                            <h2>Real-Time Decision Making</h2>
                            <p>
                              Real-time insights and automated alerts allowed
                              for proactive management and quick adjustments to
                              changing conditions.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="dataWraps">
                      <p>
                        The successful implementation of predictive analytics in
                        the construction industry demonstrates the
                        transformative potential of advanced forecasting tools
                        in enhancing operational efficiency and achieving
                        business goals.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffAugFaqWrap">
              <div class="container d-flex">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="ttlWrap ttlCenter">
                      <h2>FAQ</h2>
                    </div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            What's the difference between prediction and
                            forecasting?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Prediction involves estimating future outcomes
                              based on historical data, while forecasting is
                              more specific to estimating future trends and
                              patterns.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How accurate are your predictive models?
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Our models are built using advanced techniques to
                              ensure high accuracy, though it can vary based on
                              data quality and the specific use case.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Can small businesses benefit from analytics?
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <p>
                              Absolutely. Analytics can help businesses of all
                              sizes make informed decisions, understand customer
                              behavior, and optimize operations.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 ht100p">
                    <div className="rightWrap">
                      <h2>Elevate Your Business with Data-Driven Insights</h2>
                      <p>
                        Ready to unlock the full potential of your data with our
                        Prediction, Forecasting, and Analytics services? Contact
                        us today to discover how we can help you turn data into
                        your most valuable asset.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="servCaseStudyWrap aimlChatBotCaseStudy">
                            <div class="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="ttlWrap">
                                            <h2>Case Studies</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <ul>
                                            <li>
                                                <div class="itemWrap bgClr1">
                                                    <div className="dataWrap">
                                                        <h2>Driving Retail Success Through Advanced Forecasting</h2>
                                                        <p><strong>Challenge:</strong> A retailer struggling with overstock and stockouts.</p>
                                                        <p><strong>Solution:</strong>Implemented a machine learning model to forecast demand accurately.</p>
                                                        <p><strong>Outcome:</strong> Achieved a 20% reduction in inventory costs and improved customer satisfaction.</p>
                                                    </div>
                                                    <div className="imgWrap">
                                                        <img src={productsliderImg1} className="img-fluid" alt="" />
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="itemWrap bgClr2">
                                                    <div className="imgWrap">
                                                        <img src={productsliderImg2} className="img-fluid" alt="" />
                                                    </div>
                                                    <div className="dataWrap">
                                                        <h2>Optimizing Healthcare Delivery with Predictive Analytics</h2>
                                                        <p><strong>Challenge:</strong>  A hospital facing high readmission rates.</p>
                                                        <p><strong>Solution:</strong>Developed a predictive model to identify at-risk patients.</p>
                                                        <p><strong>Outcome:</strong> Reduced readmissions by 30%, enhancing patient care and operational efficiency.</p>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </section>
        )}
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Why Choose Hummingtec Solutions for Your AI Needs?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    With Hummingtec Solutions, you gain a partner committed to
                    innovation and excellence. Our team of AI experts is
                    dedicated to developing solutions that not only meet but
                    exceed your expectations. By choosing Hummingtec, you're
                    investing in a future where AI technology propels your
                    business to new heights of success.
                  </p>
                  <p>
                    Embrace the future with Hummingtec Solutions' AI services.
                    Contact us today to learn how our AI expertise can benefit
                    your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default AIMLDetails;
